import React, { Component, useRef, useState, useEffect, useCallback, useMemo, useReducer, createElement } from 'react';
import axios from 'axios';
import get from 'lodash/get';
import startCase from 'lodash/startCase';
import isEqual from 'lodash/isEqual';
import { captureException } from '@sentry/browser';
import { getIsMobile, queryString as queryString$1, getGlobalWindow, getIsAppWebView, saveMatchedPropertyEligibilityDetails, getEntrySource, clearDetailedAddressSearchResult, saveZoIneligibleDetails, setDetailedAddressSearchResult } from '@zillow/zo-environment-utils';
import { track as track$1, event, trackAsync } from '@zillow/zo-tracking-util';
import GDPClient from '@zillow/zog-gdp-client';
import { track, setdim } from '@zillow/universal-analytics';
import LeadContactForm from '@zillow/zo-lead-contact-form';
import styled, { css, ThemeProvider } from 'styled-components';
import { Input, token, Paragraph, Flex, Button, Alert, ModalDialog, StyledDialog, DialogBody, mediaMixin, Heading, ButtonGroup, TextButton, Text, Anchor, DialogHeader, IconError, Spacer, Label, spaceMixin, Divider, ThemeConstellation } from '@zillow/constellation';
import debounce from 'lodash/debounce';
import trim from 'lodash/trim';
import queryString from 'query-string';
import { isFinite } from 'lodash';

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
  try {
    var info = gen[key](arg);
    var value = info.value;
  } catch (error) {
    reject(error);
    return;
  }

  if (info.done) {
    resolve(value);
  } else {
    Promise.resolve(value).then(_next, _throw);
  }
}

function _asyncToGenerator(fn) {
  return function () {
    var self = this,
        args = arguments;
    return new Promise(function (resolve, reject) {
      var gen = fn.apply(self, args);

      function _next(value) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
      }

      function _throw(err) {
        asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
      }

      _next(undefined);
    });
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _taggedTemplateLiteral(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var KEYCODE_ENTER = 13;
var KEYCODE_ESCAPE = 27;
var KEYCODE_UP_ARROW = 38;
var KEYCODE_DOWN_ARROW = 40;
class AutocompletePopoverList extends Component {
  constructor(props) {
    super(props);
    this.onMouseDown = this.onMouseDown.bind(this);
    this.onKeyPress = this.onKeyPress.bind(this);
    this.onMouseEnter = this.onMouseEnter.bind(this);
    this.state = {
      activeIndex: -1
    };
  }

  componentDidMount() {
    if (this.props.visible) {
      this.addKeyPress();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (this.props.visible && !nextProps.visible) {
      this.resetActiveIndex();
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.visible && !this.props.visible) {
      this.removeKeyPress();
    } else if (this.props.visible && !prevProps.visible) {
      this.addKeyPress();
    }
  }

  componentWillUnmount() {
    this.removeKeyPress();
  }

  onMouseDown(e) {
    e.preventDefault();
    this.props.onSelect({
      address: e.target.dataset.activeItemAddress,
      zpid: e.target.dataset.activeItemZpid
    });
  }

  onKeyPress(e) {
    var {
      activeIndex
    } = this.state;
    var nextIndex;

    switch (e.keyCode) {
      case KEYCODE_ENTER:
        {
          var activeItem = this.props.items[activeIndex];

          if (activeItem) {
            e.preventDefault();
            this.props.onSelect(activeItem);
          }

          break;
        }

      case KEYCODE_ESCAPE:
        e.stopPropagation();
        e.preventDefault();
        this.props.onClose();
        break;

      case KEYCODE_UP_ARROW:
        e.preventDefault();
        nextIndex = Math.max(0, activeIndex - 1);
        break;

      case KEYCODE_DOWN_ARROW:
        e.preventDefault();
        nextIndex = Math.min(activeIndex + 1, this.props.items.length - 1);
        break;

      default:
        return;
    }

    if (isFinite(nextIndex)) {
      this.setState({
        activeIndex: nextIndex
      });
    }
  }

  onMouseEnter() {
    this.resetActiveIndex();
  }

  addKeyPress() {
    if (typeof global.document !== 'undefined') {
      global.document.addEventListener('keydown', this.onKeyPress);
    }
  }

  removeKeyPress() {
    if (typeof global.document !== 'undefined') {
      global.document.removeEventListener('keydown', this.onKeyPress);
    }
  }

  resetActiveIndex() {
    this.setState({
      activeIndex: -1
    });
  }

  render() {
    var {
      activeIndex
    } = this.state;
    var {
      items,
      visible,
      PopoverList,
      PopoverListItem
    } = this.props;

    if (!visible) {
      return null;
    }

    return /*#__PURE__*/React.createElement(PopoverList, null, items.map((value, index) => /*#__PURE__*/React.createElement(PopoverListItem, {
      key: value.zpid,
      isActive: activeIndex === index,
      "data-active-item-zpid": value.zpid,
      "data-active-item-address": value.address,
      onMouseDown: this.onMouseDown,
      onMouseEnter: this.onMouseEnter
    }, value.address)));
  }

}
AutocompletePopoverList.defaultProps = {
  onClose: () => {},
  onSelect: () => {}
};

var _excluded = ["hideResults", "showResults"];

var _templateObject;
var StyledInput = styled(Input)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border-radius: 5px;\n    text-overflow: ellipsis;\n    height: 100% !important;\n"])), token('colors.white'));

var AddressSearchInput = _ref => {
  var props = _objectWithoutProperties(_ref, _excluded);

  return (
    /*#__PURE__*/
    // before changing or removing name="address", please ask consumers as it may be relied upon
    React.createElement(StyledInput, _extends({
      name: "address",
      className: "address-search-input"
    }, props))
  );
};

var _excluded$1 = ["children"];

var _templateObject$1;
var StyleWrapper = styled.div(_templateObject$1 || (_templateObject$1 = _taggedTemplateLiteral(["\n    height: 61px;\n    position: relative;\n"])));

var AddressSearchWrapper = _ref => {
  var {
    children
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded$1);

  return /*#__PURE__*/React.createElement(StyleWrapper, _extends({
    className: "address-search"
  }, props), children);
};

var _excluded$2 = ["children", "isActive"];

var _templateObject$2, _templateObject2;
var PopoverListItemWrapper = styled(Paragraph)(_templateObject$2 || (_templateObject$2 = _taggedTemplateLiteral(["\n    border-bottom: 1px solid ", ";\n    cursor: pointer;\n    padding: 9px 0;\n\n    &.is-active,\n    &:hover {\n        background-color: ", ";\n        color: ", ";\n    }\n"])), token('colors.gray200'), token('colors.gray200'), token('colors.brand'));
var PopoverListItem = _ref => {
  var {
    children,
    isActive
  } = _ref,
      restProps = _objectWithoutProperties(_ref, _excluded$2);

  return /*#__PURE__*/React.createElement(PopoverListItemWrapper, _extends({
    "data-testid": "address-seach-popover-list-item",
    className: isActive ? 'is-active' : ''
  }, restProps), children);
};
var PopoverListWrapper = styled(Flex)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    box-shadow: 0 0 4px ", ";\n    margin-top: 4px;\n"])), token('colors.white'), token('colors.gray500'));

var PopoverList = _ref2 => {
  var {
    children
  } = _ref2;
  return /*#__PURE__*/React.createElement(PopoverListWrapper, {
    "data-testid": "address-seach-popover-list"
  }, children);
};

var JMP_BASE = '/jmp';
var Urls = {
  CHESS_AUTOCOMPLETE_URL: 'https://www.zillowstatic.com/autocomplete/v3/suggestions',
  CHESS_AUTOCOMPLETE_URL_QA: 'https://static.qa.zillow.net/autocomplete/v3/suggestions',
  LEAD_ELIGIBILITY_CHECK: "".concat(JMP_BASE, "/lead-eligibility"),
  LEADS_NURTURE: "".concat(JMP_BASE, "/leads/nurture"),
  LEADS_PARTNER_LEADS_ELIGIBILITY_LIST: "".concat(JMP_BASE, "/leads/partner-leads-interest-list"),
  TERMS_OF_SERVICE_PATH: '/corp/Terms.htm',
  ZILLOW_OFFERS_ADDRESS_SEARCH: "".concat(JMP_BASE, "/address-search"),
  ZILLOW_OFFERS_DETAILED_ADDRESS_SEARCH: "".concat(JMP_BASE, "/detailed-address-search"),
  ZILLOW_OFFERS_SELLER_QUESTIONNAIRE_ELIGIBILITY_CHECK: "".concat(JMP_BASE, "/questionnaire-eligibility-check")
};

var state = {
  autocompleteUrl: Urls.CHESS_AUTOCOMPLETE_URL
};
var getAutocompleteUrl = () => state.autocompleteUrl;
var setAutocompleteUrl = autocompleteUrl => {
  state.autocompleteUrl = autocompleteUrl;
};

var EMPTY_RESULTS = [];

class AddressSearch extends Component {
  constructor(props) {
    super(props);
    this.onChange = this.onChange.bind(this);
    this.onChoice = this.onChoice.bind(this); // we use an axios source for cancelling the most recent request for autocomplete suggestions
    // when a new request is made, so that the address component always renders the most recent
    // fetched autocomplete suggestions correctly

    this.refreshMostRecentAxiosSource = this.refreshMostRecentAxiosSource.bind(this);
    this.getResults = debounce(this.getResults.bind(this), 333, {
      maxWait: 1000
    });
    this.clearResults = this.clearResults.bind(this);
    this.hideResults = this.hideResults.bind(this);
    this.showResults = this.showResults.bind(this);
    this.axiosInstance = axios.create({
      timeout: this.props.requestTimeout,
      validateStatus: status => status === 200
    });
    this.state = {
      address: props.defaultAddress,
      location: props.location || {},
      results: EMPTY_RESULTS,
      resultsVisible: false
    };
  }

  componentDidMount() {
    if (this.props.useDeviceLocation && !this.state.location.latitude) {
      this.getLocation();
    }
  }

  componentWillUnmount() {
    // refresh the most axios source to cancel any in-flight request before unmount
    this.refreshMostRecentAxiosSource();
    this.isUnmounting = true;
  }

  onChange(e) {
    e.preventDefault();
    var address = e.target.value;
    this.setState({
      address
    }, () => {
      this.props.onChange(address); // when input changes, always refresh the most recent axios source
      // by cancelling it and creating a new one

      this.refreshMostRecentAxiosSource();

      if (!address) {
        this.clearResults();
        this.hideResults();
      }

      if (this.props.autocompleteEnabled && typeof address === 'string' && address.trim().length > 3) {
        this.getResults(address, this.mostRecentAxiosSource);
      }
    });
  }

  onChoice(selection) {
    var {
      address,
      zpid
    } = selection;
    this.hideResults();
    this.setState({
      address
    }, () => {
      this.props.onChange(address);
      this.props.onChoice(zpid);
    });
  }

  getLocation() {
    var navigator = global.navigator || {};

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        if (!this.isUnmounting) {
          this.setState({
            location: {
              latitude: position.coords.latitude,
              longitude: position.coords.longitude
            }
          });
        }
      });
    }
  }

  getResults(prefix, axiosSource) {
    var _this = this;

    return _asyncToGenerator(function* () {
      var {
        latitude,
        longitude
      } = _this.state.location;
      var params = {
        q: trim(prefix),
        resultCount: _this.props.maxSuggestions,
        resultTypes: 'allAddress'
      };

      if (latitude && longitude) {
        params.userLat = latitude;
        params.userLon = longitude;
      } // consumers can specify url in an init file, it will default to production url


      var autocompleteUrl = getAutocompleteUrl();
      var url = [autocompleteUrl, queryString.stringify(params)].join('?');

      try {
        var _response$data$result, _response$data;

        var response = yield _this.axiosInstance.get(url, {
          cancelToken: axiosSource.token
        });
        var results = ((_response$data$result = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.results) !== null && _response$data$result !== void 0 ? _response$data$result : []).map(item => {
          var _address$zpid, _item$metaData;

          return (_address$zpid = {
            address: item === null || item === void 0 ? void 0 : item.display,
            zpid: item === null || item === void 0 ? void 0 : (_item$metaData = item.metaData) === null || _item$metaData === void 0 ? void 0 : _item$metaData.zpid
          }) !== null && _address$zpid !== void 0 ? _address$zpid : {};
        });

        _this.setState({
          results,
          resultsVisible: results.length > 0
        });
      } catch (err) {
        if (!axios.isCancel(err)) {
          _this.props.onError(err);
        }
      }
    })();
  }

  clearResults() {
    this.setState({
      results: EMPTY_RESULTS,
      resultsVisible: false
    });
  }

  hideResults() {
    this.setState({
      resultsVisible: false
    });
  }

  showResults() {
    this.setState(prevState => ({
      resultsVisible: prevState.results.length > 0
    }));
  }

  refreshMostRecentAxiosSource() {
    if (this.mostRecentAxiosSource) {
      this.mostRecentAxiosSource.cancel();
    }

    this.mostRecentAxiosSource = axios.CancelToken.source();
  }

  render() {
    var {
      children,
      disabled,
      id,
      onFocus: _onFocus,
      onKeyDown,
      placeholder,
      WrapperComponent,
      InputComponent,
      PopoverListComponent,
      PopoverListItemComponent
    } = this.props;
    var {
      address,
      results,
      resultsVisible
    } = this.state; // support literal <children /> _or_ a render prop, breaking changes are bad

    var render = typeof children === 'function' ? children : () => children;
    return /*#__PURE__*/React.createElement(WrapperComponent, {
      id: id
    }, /*#__PURE__*/React.createElement(InputComponent, {
      autoComplete: "off",
      disabled: disabled,
      onChange: this.onChange,
      onKeyDown: onKeyDown,
      onFocus: () => _onFocus() && this.showResults(),
      onBlur: resultsVisible ? null : this.hideResults,
      placeholder: placeholder,
      value: address,
      hideResults: this.hideResults,
      showResults: this.showResults
    }), /*#__PURE__*/React.createElement(AutocompletePopoverList, {
      items: results,
      visible: resultsVisible,
      onSelect: this.onChoice,
      onClose: this.hideResults,
      PopoverList: PopoverListComponent,
      PopoverListItem: PopoverListItemComponent
    }), render({
      resultsVisible
    }));
  }

}
/* eslint-disable sort-keys */


AddressSearch.defaultProps = {
  autocompleteEnabled: true,
  defaultAddress: '',
  disabled: false,
  id: 'address-search',
  location: {},
  maxSuggestions: 5,
  onChange: () => {},
  onChoice: () => {},
  onError: () => {},
  onFocus: () => {},
  onKeyDown: () => {},
  placeholder: '',
  requestTimeout: 3000,
  useDeviceLocation: true,
  WrapperComponent: AddressSearchWrapper,
  InputComponent: AddressSearchInput,
  PopoverListComponent: PopoverList,
  PopoverListItemComponent: PopoverListItem
};

var _excluded$3 = ["isButtonDisabled", "buttonText", "errorMessage", "isPending", "onChange", "onChoice", "onFocus", "onSubmit", "defaultAutofillAddress", "addressSearchFormPlaceholder"];

var _templateObject$3, _templateObject2$1;
var StyleWrapper$1 = styled.div(_templateObject$3 || (_templateObject$3 = _taggedTemplateLiteral(["\n    margin-bottom: 8px;\n    width: 100%;\n\n    .address-search-error {\n        padding: 8px 16px;\n        width: 100%;\n    }\n"])));
var StyledForm = styled.form(_templateObject2$1 || (_templateObject2$1 = _taggedTemplateLiteral(["\n    margin-bottom: 16px;\n    position: relative;\n    width: 100%;\n    z-index: 99;\n\n    /* avoid from being covered by the submit button */\n    .address-search-input {\n        padding-left: 15px !important;\n        padding-right: 140px !important;\n    }\n\n    .submit-button {\n        height: 42px;\n        position: absolute;\n        right: 8px;\n        top: 10px;\n        width: ", "px;\n    }\n"])), getIsMobile ? '125' : '200');

var AddressSearchForm = _ref => {
  var {
    isButtonDisabled,
    buttonText,
    errorMessage,
    isPending,
    onChange: _onChange,
    onChoice,
    onFocus,
    onSubmit,
    defaultAutofillAddress,
    addressSearchFormPlaceholder
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$3);

  var addressSearchRef = useRef(null);
  var [addressSearchText, setAddressSearchText] = useState(defaultAutofillAddress);
  useEffect(() => {
    setAddressSearchText(defaultAutofillAddress);
  }, [defaultAutofillAddress]);
  var onFormSubmit = useCallback(text => {
    // cancel the most recent debounced auto-suggestion async call
    addressSearchRef.current.getResults.cancel();
    addressSearchRef.current.hideResults();
    onSubmit(text);
  }, [addressSearchRef, onSubmit]);
  var onAutocompleteError = useCallback(e => {
    captureException(e, {
      tags: {
        message: 'zo-address-search autocomplete error'
      }
    });
  }, []);
  var canSubmit = useMemo(() => !isPending && !isButtonDisabled, [isPending, isButtonDisabled]);
  return /*#__PURE__*/React.createElement(StyleWrapper$1, null, /*#__PURE__*/React.createElement(StyledForm, _extends({
    "data-testid": "address-seach-box-form",
    onSubmit: e => {
      // prevent page from reloading due to form submission
      e.preventDefault();

      if (canSubmit) {
        onFormSubmit(addressSearchText);
      }
    }
  }, otherProps), /*#__PURE__*/React.createElement(AddressSearch, {
    key: defaultAutofillAddress,
    id: "zo-address-search",
    ref: addressSearchRef,
    placeholder: addressSearchFormPlaceholder,
    onFocus: onFocus,
    disabled: isPending,
    onChange: text => {
      setAddressSearchText(text);

      _onChange(text);
    },
    onError: onAutocompleteError,
    onChoice: onChoice,
    useDeviceLocation: false,
    defaultAddress: defaultAutofillAddress
  }), /*#__PURE__*/React.createElement(Button, {
    buttonType: "primary",
    disabled: !canSubmit,
    className: "submit-button"
  }, isPending ? 'Loading...' : buttonText)), errorMessage && /*#__PURE__*/React.createElement(Alert, {
    appearance: "error",
    className: "address-search-error",
    body: errorMessage,
    icon: null
  }));
};

AddressSearchForm.defaultProps = {
  addressSearchFormPlaceholder: '',
  buttonText: 'Get started',
  defaultAutofillAddress: '',
  errorMessage: '',
  isButtonDisabled: false,
  onFocus: () => {}
};

var ZillowOffersGrowthRoutes = {
  APP_VERSION: '/static-zo-growth-version',
  HAVE_YOU_REQUEST_OFFER: '/questionnaire/have-you-request-offer/',
  OFFER_REQUEST_RENEW: '/request-renew/:offerRequestId',
  REQUEST_UPDATED_OFFER: '/questionnaire/request-updated-offer/:zpid/:offerRequestId',
  REQUEST_UPDATED_OFFER_NO_ORID: '/questionnaire/request-updated-offer/:zpid',
  SELLER_ADVISOR: '/seller-advisor/',
  SELLER_ADVISOR_CONFIRM: '/seller-advisor/confirm/',
  SELLER_ADVISOR_CONTACT_INFO: '/seller-advisor/contact-info/',
  SELLER_ADVISOR_EMAIL_WAITLIST: '/seller-advisor/email-waitlist/',
  // trailing slash in SELLER_ADVISOR_SELLER_GUIDE helps prevent 301 redirect from cloudfront
  // plus, it keeps location.history.state intact which in turn is used to store termination config
  SELLER_ADVISOR_SELLER_GUIDE: '/seller-advisor/seller-guide/',
  SELLER_LANDING: '/',
  SELLER_LANDING_HOMEBUILDERS: '/homebuilders/:partner?',
  SELLER_LANDING_MARKET_DEFAULT: '/markets/:market',
  SELLER_QUESTIONNAIRE_V2: '/question/:slideId',
  SELLER_QUESTIONNAIRE_V2_INDEXLESS: '/question',
  SELLER_QUESTIONNAIRE_V3_INDEXLESS: '/questionnaire/'
};
var ZILLOW_OFFERS_BASE_NAME = '/offers';

var trackOffersEvent = eventParams => {
  track(_objectSpread2({
    category: 'InstantOffer'
  }, eventParams));
};

var _templateObject$4;
var StyledModalDialog = styled(ModalDialog).attrs({
  fullScreen: true,
  mediaQuery: {
    md: {
      fullScreen: false
    }
  },
  scrollDocument: true,
  shouldCloseOnOutsideClick: false,
  wide: true
})(_templateObject$4 || (_templateObject$4 = _taggedTemplateLiteral(["\n    align-items: flex-start;\n\n    @media screen and (max-width: 300px) {\n        h6 {\n            width: 80%;\n            margin: 0 auto;\n        }\n    }\n\n    ", " {\n        ", " {\n            box-sizing: content-box;\n            ", "\n        }\n    }\n"])), StyledDialog, DialogBody, mediaMixin('md', css(["width:400px;margin:auto;min-height:535px;max-height:535px;"])));

var _excluded$4 = ["city", "state", "street", "unit", "zipcode", "onClick"],
    _excluded2 = ["isOpen", "isPending", "onClose", "onClickNoneOfAbove", "onSelect", "properties"];

var _templateObject$5, _templateObject2$2;
var GA_ACTION = 'Addresspicker';
var StyledFlex = styled(Flex)(_templateObject$5 || (_templateObject$5 = _taggedTemplateLiteral(["\n    border-bottom: 2px solid ", ";\n    padding: 16px 0;\n"])), token('colors.gray200'));

var AddressItem = _ref => {
  var {
    city,
    state,
    street,
    unit,
    zipcode,
    onClick
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$4);

  return /*#__PURE__*/React.createElement(StyledFlex, otherProps, /*#__PURE__*/React.createElement(Text, {
    fontType: "h6"
  }, /*#__PURE__*/React.createElement(Anchor, {
    style: {
      fontWeight: '600'
    },
    onClick: onClick,
    "data-testid": "address-item"
  }, street, " ", unit)), /*#__PURE__*/React.createElement(Paragraph, null, "".concat(city, ", ").concat(state, " ").concat(zipcode)));
};

AddressItem.defaultProps = {
  onClick: () => {},
  unit: ''
};
var ModalDialogBodyStyleWrapper = styled.div(_templateObject2$2 || (_templateObject2$2 = _taggedTemplateLiteral(["\n    .address-item:last-of-type {\n        border-bottom: none;\n    }\n"])));

var SelectAddressDialog = _ref2 => {
  var {
    isOpen,
    isPending,
    onClose: _onClose,
    onClickNoneOfAbove,
    onSelect,
    properties
  } = _ref2,
      otherProps = _objectWithoutProperties(_ref2, _excluded2);

  useEffect(() => {
    if (isOpen) {
      track$1(event('zo.zpidsearch.display', {
        action_is_auto: true,
        content: 'picker',
        ga_action: GA_ACTION,
        ga_label: 'Display',
        object: 'dialog'
      }));
    }
  }, [isOpen]);
  var top10Properties = properties.slice(0, 10);
  return /*#__PURE__*/React.createElement(StyledModalDialog, _extends({
    header: /*#__PURE__*/React.createElement(Heading, {
      level: 6
    }, "Confirm your address below"),
    body: /*#__PURE__*/React.createElement(ModalDialogBodyStyleWrapper, null, /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "xs",
      marginBottom: "xs"
    }, "We found multiple homes with that address."), top10Properties.length > 0 && top10Properties.map(property => /*#__PURE__*/React.createElement(AddressItem, _extends({
      className: "address-item",
      onClick: () => {
        track$1(event('zo.zpidsearch.click', {
          content: 'picker',
          ga_action: GA_ACTION,
          ga_label: 'Click Results',
          object: 'results'
        }));
        onSelect(property.zpid);
      },
      key: property.zpid
    }, property.address)))),
    footer: /*#__PURE__*/React.createElement(ButtonGroup, {
      "aria-label": "select address dialog buttons"
    }, /*#__PURE__*/React.createElement(TextButton, {
      disabled: isPending,
      onClick: _onClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      disabled: isPending,
      buttonType: "secondary",
      onClick: () => {
        track$1(event('zo.zpidsearch.click', {
          content: 'picker',
          ga_action: GA_ACTION,
          ga_label: 'Click',
          object: 'button'
        }));
        onClickNoneOfAbove();
      }
    }, "None of the above")),
    isOpen: isOpen,
    onClose: () => {
      trackOffersEvent({
        action: GA_ACTION,
        label: 'Close'
      });

      _onClose();
    }
  }, otherProps));
};

SelectAddressDialog.defaultProps = {
  isOpen: false,
  isPending: false,
  onClickNoneOfAbove: () => {},
  onClose: () => {},
  onSelect: () => {},
  properties: []
};

var _templateObject$6;
var googleStaticMapSignedUrlQuery = {
  "kind": "Document",
  "definitions": [{
    "kind": "OperationDefinition",
    "operation": "query",
    "name": {
      "kind": "Name",
      "value": "googleStaticMapSignedUrlQuery"
    },
    "variableDefinitions": [{
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "apiKey"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "String"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "zpid"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "ID"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "width"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      },
      "directives": []
    }, {
      "kind": "VariableDefinition",
      "variable": {
        "kind": "Variable",
        "name": {
          "kind": "Name",
          "value": "height"
        }
      },
      "type": {
        "kind": "NonNullType",
        "type": {
          "kind": "NamedType",
          "name": {
            "kind": "Name",
            "value": "Int"
          }
        }
      },
      "directives": []
    }],
    "directives": [],
    "selectionSet": {
      "kind": "SelectionSet",
      "selections": [{
        "kind": "Field",
        "name": {
          "kind": "Name",
          "value": "property"
        },
        "arguments": [{
          "kind": "Argument",
          "name": {
            "kind": "Name",
            "value": "zpid"
          },
          "value": {
            "kind": "Variable",
            "name": {
              "kind": "Name",
              "value": "zpid"
            }
          }
        }],
        "directives": [],
        "selectionSet": {
          "kind": "SelectionSet",
          "selections": [{
            "kind": "Field",
            "name": {
              "kind": "Name",
              "value": "googleStaticMapSignedUrl"
            },
            "arguments": [{
              "kind": "Argument",
              "name": {
                "kind": "Name",
                "value": "type"
              },
              "value": {
                "kind": "EnumValue",
                "value": "ROAD"
              }
            }, {
              "kind": "Argument",
              "name": {
                "kind": "Name",
                "value": "key"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "apiKey"
                }
              }
            }, {
              "kind": "Argument",
              "name": {
                "kind": "Name",
                "value": "width"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "width"
                }
              }
            }, {
              "kind": "Argument",
              "name": {
                "kind": "Name",
                "value": "height"
              },
              "value": {
                "kind": "Variable",
                "name": {
                  "kind": "Name",
                  "value": "height"
                }
              }
            }],
            "directives": []
          }]
        }
      }]
    }
  }],
  "loc": {
    "start": 0,
    "end": 245,
    "source": {
      "body": "\n    query googleStaticMapSignedUrlQuery($apiKey: String!, $zpid: ID!, $width: Int!, $height: Int!) {\n        property(zpid: $zpid) {\n            googleStaticMapSignedUrl(type: ROAD, key: $apiKey, width: $width, height: $height)\n        }\n    }\n",
      "name": "GraphQL request",
      "locationOffset": {
        "line": 1,
        "column": 1
      }
    }
  }
};
var StyleWrapper$2 = styled.div(_templateObject$6 || (_templateObject$6 = _taggedTemplateLiteral(["\n    height: 0;\n    padding-left: 100%;\n    padding-top: 64%;\n    position: relative;\n    width: 0;\n\n    .loading-message {\n        font-size: 14px;\n        left: 0;\n        position: absolute;\n        text-align: center;\n        top: 50%;\n        width: 100%;\n    }\n\n    img {\n        height: 100%;\n        left: 0;\n        position: absolute;\n        top: 0;\n        width: 100%;\n    }\n\n    #map-marker {\n        background-color: ", ";\n        border: solid 2px ", ";\n        border-radius: 50%;\n        box-shadow: 0 2px 2px rgba(0, 0, 0, 0.5);\n        height: 15px;\n        left: 50%;\n        margin-left: -7.5px;\n        margin-top: -7.5px;\n        pointer-events: none;\n        position: absolute;\n        top: 50%;\n        width: 15px;\n    }\n"])), token('colors.black'), token('colors.white'));

var GoogleMapImage = _ref => {
  var {
    apiKey,
    apolloClient,
    zpid
  } = _ref;
  var [googleMapSignedUrl, setGoogleMapSignedUrl] = useState('');
  var [loading, setLoading] = useState(true);
  var [failed, setFailed] = useState(false);
  useEffect(() => {
    function getGoogleStaticMapSignedUrl() {
      return _getGoogleStaticMapSignedUrl.apply(this, arguments);
    }

    function _getGoogleStaticMapSignedUrl() {
      _getGoogleStaticMapSignedUrl = _asyncToGenerator(function* () {
        setLoading(true);

        try {
          var {
            data
          } = yield apolloClient.query({
            query: googleStaticMapSignedUrlQuery,
            variables: {
              apiKey,
              height: 576,
              width: 768,
              zpid
            }
          });
          setGoogleMapSignedUrl(get(data, 'property.googleStaticMapSignedUrl'));
        } catch (err) {
          setFailed(true);
          console.error(err);
          captureException(err);
        } finally {
          setLoading(false);
        }
      });
      return _getGoogleStaticMapSignedUrl.apply(this, arguments);
    }

    getGoogleStaticMapSignedUrl();
  }, [apiKey, zpid, apolloClient]);

  if (loading) {
    return /*#__PURE__*/React.createElement(StyleWrapper$2, null, /*#__PURE__*/React.createElement(Text, {
      className: "loading-message"
    }, "Loading map..."));
  }

  if (failed) {
    return /*#__PURE__*/React.createElement(StyleWrapper$2, null, /*#__PURE__*/React.createElement(Text, {
      className: "loading-message"
    }, "Unable to load map."));
  }

  return /*#__PURE__*/React.createElement(StyleWrapper$2, null, /*#__PURE__*/React.createElement("img", {
    alt: "google map",
    src: googleMapSignedUrl,
    "data-testid": "google-map"
  }), /*#__PURE__*/React.createElement("span", {
    id: "map-marker"
  }));
};

var _excluded$5 = ["address", "apolloClient", "isOpen", "isPending", "onClickConfirm", "onClickFixAddress", "onClose", "zpid"];

var _templateObject$7, _templateObject2$3, _templateObject3;

var GOOGLE_MAP_API_KEY = 'AIzaSyDjPtw3XZx2itawNy2s0jWCO3-SbCFoykw';
var GA_ACTION$1 = 'Addressconfirmation';
var ConfirmAddressModalDialog = styled(StyledModalDialog)(_templateObject$7 || (_templateObject$7 = _taggedTemplateLiteral(["\n    ", " {\n        overflow: hidden;\n\n        ", " {\n            padding: 0;\n            max-height: 376px;\n            overflow: hidden;\n        }\n\n        ", " {\n            border-top: none;\n            ", "\n        }\n    }\n"])), StyledDialog, DialogHeader, DialogBody, mediaMixin('md', css(["max-height:254px;min-height:254px;"])));
var ModalBodyStyleWrapper = styled.div(_templateObject2$3 || (_templateObject2$3 = _taggedTemplateLiteral(["\n    text-align: center;\n"])));
var StyledGoogleMapImage = styled(GoogleMapImage)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n    border-top-left-radius: 8px;\n    border-top-right-radius: 8px;\n"])));
var ConfirmAddressDialog = _ref => {
  var {
    address,
    apolloClient,
    isOpen,
    isPending,
    onClickConfirm,
    onClickFixAddress,
    onClose: _onClose,
    zpid
  } = _ref,
      otherProps = _objectWithoutProperties(_ref, _excluded$5);

  useEffect(() => {
    if (isOpen) {
      track$1(event('zo.zpidsearch.display', {
        action_is_auto: true,
        content: 'confirmation',
        ga_action: GA_ACTION$1,
        ga_label: 'Display',
        object: 'dialog'
      }));
    }
  }, [isOpen]);
  return /*#__PURE__*/React.createElement(ConfirmAddressModalDialog, _extends({
    header: /*#__PURE__*/React.createElement(StyledGoogleMapImage, {
      apiKey: GOOGLE_MAP_API_KEY,
      apolloClient: apolloClient,
      zpid: zpid
    }),
    body: /*#__PURE__*/React.createElement(ModalBodyStyleWrapper, null, /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "md",
      marginBottom: "xs"
    }, "Is this the correct address?"), address && /*#__PURE__*/React.createElement(Heading, {
      level: "4"
    }, address.street, " ", address.unit || '', " ", /*#__PURE__*/React.createElement("br", null), address.city, ", ", address.state, " ", address.zipcode)),
    footer: /*#__PURE__*/React.createElement(ButtonGroup, {
      "aria-label": "confirm address dialog buttons"
    }, /*#__PURE__*/React.createElement(TextButton, {
      disabled: isPending,
      onClick: () => {
        track$1(event('zo.zpidsearch.click', {
          content: 'confirmation',
          ga_action: GA_ACTION$1,
          ga_label: 'Click Fix Address',
          object: 'fixaddress'
        }));
        onClickFixAddress();
      }
    }, "Fix address"), /*#__PURE__*/React.createElement(Button, {
      disabled: isPending,
      buttonType: "primary",
      onClick: () => {
        track$1(event('zo.zpidsearch.click', {
          content: 'confirmation',
          ga_action: GA_ACTION$1,
          ga_label: 'Click',
          object: 'button'
        }));
        onClickConfirm(zpid);
      }
    }, "Yes, correct")),
    onClose: () => {
      trackOffersEvent({
        action: GA_ACTION$1,
        label: 'Close'
      });

      _onClose();
    },
    isOpen: isOpen
  }, otherProps));
};
ConfirmAddressDialog.defaultProps = {
  address: null,
  isOpen: false,
  isPending: false,
  onClickConfirm: () => {},
  onClickFixAddress: () => {},
  onClose: () => {},
  zpid: 0
};

var PhoneNumbers = {
  ZILLOW_ADVISOR_TEAM: '18339633377',
  ZILLOW_ADVISOR_TEAM_DISPLAY: '1-833-ZOFFERS'
};

var _templateObject$8, _templateObject2$4;
var StyledFlex$1 = styled(Flex).attrs({
  display: 'flex',
  flexDirection: 'row'
})(_templateObject$8 || (_templateObject$8 = _taggedTemplateLiteral(["\n    background-color: ", ";\n    border: 1px solid ", ";\n    border-radius: 4px;\n    padding: 8px;\n"])), token('colors.red100'), token('colors.red400'));
var StyledErrorIcon = styled(IconError)(_templateObject2$4 || (_templateObject2$4 = _taggedTemplateLiteral(["\n    color: ", ";\n"])), token('colors.red400'));

var AddressSearchErrorMessage = () => {
  var addressSearchErrorRef = /*#__PURE__*/React.createRef();
  useEffect(() => {
    addressSearchErrorRef.current.scrollIntoView();
  }, [addressSearchErrorRef]);
  return /*#__PURE__*/React.createElement(StyledFlex$1, {
    ref: addressSearchErrorRef
  }, /*#__PURE__*/React.createElement(Paragraph, null, /*#__PURE__*/React.createElement(StyledErrorIcon, null)), /*#__PURE__*/React.createElement(Spacer, {
    marginLeft: "xs"
  }, /*#__PURE__*/React.createElement(Paragraph, null, "We're having trouble finding your address. Please contact a Zillow Advisor at\xA0", /*#__PURE__*/React.createElement(Anchor, {
    href: "tel:".concat(PhoneNumbers.ZILLOW_ADVISOR_TEAM)
  }, PhoneNumbers.ZILLOW_ADVISOR_TEAM_DISPLAY))));
};

var _excluded$6 = ["hasError", "isOpen", "isPending", "onClose", "onSubmit"];
var GA_ACTION$2 = 'ZipcodeSubmit';

var ZipCodeInputDialog = _ref => {
  var {
    hasError,
    isOpen,
    isPending,
    onClose: _onClose,
    onSubmit
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded$6);

  var [zipcode, setZipcode] = useState('');
  useEffect(() => {
    if (isOpen) {
      track$1(event('zo.zpidsearch.display', {
        action_is_auto: true,
        content: 'zip_code_entry',
        ga_action: GA_ACTION$2,
        ga_label: 'Display',
        object: 'form'
      }));
    }

    if (!isOpen || !isPending) {
      setZipcode('');
    }
  }, [isOpen, isPending]);
  return /*#__PURE__*/React.createElement(ModalDialog, _extends({
    mediaQuery: {
      md: {
        fullScreen: false
      }
    },
    header: /*#__PURE__*/React.createElement(Heading, {
      level: 6
    }, "Check if Zillow Offers is available in your area"),
    body: /*#__PURE__*/React.createElement(React.Fragment, null, hasError && /*#__PURE__*/React.createElement(Flex, {
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(AddressSearchErrorMessage, null)), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "xs"
    }, /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "Zip code")), /*#__PURE__*/React.createElement(Input, {
      id: "postal-code",
      name: "postal-code",
      autoComplete: "postal-code",
      type: "number",
      pattern: "[0-9]*",
      "data-testid": "zipcode-input",
      value: zipcode,
      onChange: e => setZipcode(e.target.value)
    })),
    footer: /*#__PURE__*/React.createElement(ButtonGroup, {
      "aria-label": "zipcode input dialog buttons"
    }, /*#__PURE__*/React.createElement(TextButton, {
      disabled: isPending,
      onClick: _onClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      disabled: !zipcode || isPending,
      buttonType: "primary",
      onClick: () => {
        track$1(event('zo.zpidsearch.click', {
          content: 'zip_code_entry',
          ga_action: GA_ACTION$2,
          ga_label: 'Click',
          object: 'button'
        }));
        onSubmit(zipcode);
      }
    }, "Continue")),
    isOpen: isOpen,
    onClose: () => {
      trackOffersEvent({
        action: GA_ACTION$2,
        label: 'Close'
      });

      _onClose();
    },
    shouldCloseOnOutsideClick: false,
    fullScreen: true
  }, props));
};

ZipCodeInputDialog.defaultProps = {
  hasError: false,
  isOpen: false,
  isPending: false,
  onClose: () => {},
  onSubmit: () => {}
};

var _excluded$7 = ["address", "hasError", "isOpen", "isPending", "onClose", "onSubmit", "title", "zpid"];
var GA_ACTION$3 = 'Detailedaddressentry';
var emptyFullAddress = {
  city: '',
  state: '',
  street: '',
  unit: '',
  zipcode: ''
};

var validateFullAddress = _ref => {
  var {
    city,
    street,
    state,
    zipcode
  } = _ref;
  return city && street && state && zipcode;
};

var initFullAddress = address => {
  // initialize full address object with passed-in address object
  if (address) {
    return _objectSpread2(_objectSpread2({}, emptyFullAddress), address);
  }

  return emptyFullAddress;
};

var fullAddressReducer = (state, action) => {
  switch (action.type) {
    case 'SET_CITY':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        city: action.payload
      });

    case 'INIT':
      return initFullAddress(action.payload);

    case 'SET_STATE':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        state: action.payload
      });

    case 'SET_STREET':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        street: action.payload
      });

    case 'SET_UNIT':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        unit: action.payload
      });

    case 'SET_ZIPCODE':
      return _objectSpread2(_objectSpread2({}, state), {}, {
        zipcode: action.payload
      });

    default:
      throw new Error('Failed to update full address!');
  }
};

var DetailedAddressEntryDialog = _ref2 => {
  var {
    address,
    hasError,
    isOpen,
    isPending,
    onClose: _onClose,
    onSubmit,
    title,
    zpid
  } = _ref2,
      otherProps = _objectWithoutProperties(_ref2, _excluded$7);

  var [fullAddress, dispatch] = useReducer(fullAddressReducer, address, initFullAddress);
  var canSubmit = validateFullAddress(fullAddress);
  useEffect(() => {
    if (isOpen) {
      track$1(event('zo.zpidsearch.display', {
        action_is_auto: true,
        content: 'detailed_address_entry',
        ga_action: GA_ACTION$3,
        ga_label: 'Display',
        object: 'form'
      }));
    }
  }, [isOpen]);
  useEffect(() => {
    if (!isOpen) {
      dispatch({
        payload: address,
        type: 'INIT'
      });
    }
  }, [address, isOpen]);
  useEffect(() => {
    if (hasError && isOpen) {
      track$1(event('zo.zpidsearch.failure', {
        action_is_auto: true,
        content: 'detailed_address_entry',
        ga_action: 'FailureDetailedaddressentry',
        ga_label: 'Display'
      }));
    }
  }, [hasError, isOpen]);
  return /*#__PURE__*/React.createElement(StyledModalDialog, _extends({
    header: /*#__PURE__*/React.createElement(Heading, {
      level: 6
    }, title),
    body: /*#__PURE__*/React.createElement("div", null, hasError && /*#__PURE__*/React.createElement(AddressSearchErrorMessage, null), /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "sm",
      marginBottom: "sm"
    }, "Enter your full address to continue"), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "xs"
    }, /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "Street address")), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(Input, {
      id: "street-address",
      name: "street-address",
      autoComplete: "street-address",
      "data-testid": "street-input",
      maxLength: "100",
      value: fullAddress.street,
      onChange: e => dispatch({
        payload: e.target.value,
        type: 'SET_STREET'
      })
    })), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "xs"
    }, /*#__PURE__*/React.createElement(Label, null, "Apartment, unit, suite, etc.")), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(Input, {
      id: "address-line2",
      name: "address-line2",
      autoComplete: "address-line2",
      "data-testid": "unit-input",
      maxLength: "20",
      value: fullAddress.unit,
      onChange: e => dispatch({
        payload: e.target.value,
        type: 'SET_UNIT'
      })
    })), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "xs"
    }, /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "City")), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(Input, {
      id: "address-level2",
      name: "address-level2",
      autoComplete: "address-level2",
      "data-testid": "city-input",
      maxLength: "50",
      value: fullAddress.city,
      onChange: e => dispatch({
        payload: e.target.value,
        type: 'SET_CITY'
      })
    })), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "xs"
    }, /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "State")), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(Input, {
      id: "address-level1",
      name: "address-level1",
      autoComplete: "address-level1",
      "data-testid": "state-input",
      maxLength: "20",
      value: fullAddress.state,
      onChange: e => dispatch({
        payload: e.target.value,
        type: 'SET_STATE'
      })
    })), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "sm"
    }, /*#__PURE__*/React.createElement(Label, {
      required: true
    }, "Zip code")), /*#__PURE__*/React.createElement(Spacer, {
      marginBottom: "xs"
    }, /*#__PURE__*/React.createElement(Input, {
      id: "postal-code",
      name: "postal-code",
      autoComplete: "postal-code",
      "data-testid": "zipcode-input",
      type: "number",
      pattern: "[0-9]*",
      value: fullAddress.zipcode,
      onChange: e => dispatch({
        payload: e.target.value,
        type: 'SET_ZIPCODE'
      })
    }))),
    footer: /*#__PURE__*/React.createElement(ButtonGroup, {
      "aria-label": "detailed address entry dialog buttons"
    }, /*#__PURE__*/React.createElement(TextButton, {
      disabled: isPending,
      onClick: _onClose
    }, "Cancel"), /*#__PURE__*/React.createElement(Button, {
      disabled: !canSubmit || isPending,
      buttonType: "primary",
      onClick: () => {
        track$1(event('zo.zpidsearch.click', {
          content: 'detailed_address_entry',
          ga_action: GA_ACTION$3,
          ga_label: 'Click',
          object: 'button'
        }));
        onSubmit(fullAddress);
      }
    }, "Submit")),
    isOpen: isOpen,
    onClose: () => {
      trackOffersEvent({
        action: GA_ACTION$3,
        label: 'Close'
      });

      _onClose();
    }
  }, otherProps));
};

DetailedAddressEntryDialog.defaultProps = {
  address: null,
  hasError: false,
  isOpen: false,
  isPending: false,
  onClose: () => {},
  onSubmit: () => {},
  title: 'Re-enter your address',
  zpid: 0
};

var DuplicateOfferRequestBackground = (props => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 1920 1080"
}, props), /*#__PURE__*/React.createElement("style", null, '.prefix__st1{fill:#a6e5ff}.prefix__st1,.prefix__st2{clip-path:url(#prefix__a)}.prefix__st3{fill:#e0f2ff}.prefix__st6{clip-path:url(#prefix__a);fill:#fff}.prefix__st11{clip-path:url(#prefix__b)}.prefix__st13{opacity:.5}.prefix__st14{fill:none;stroke:#0d4599;stroke-width:8.8052;stroke-miterlimit:10}.prefix__st19{clip-path:url(#prefix__a);fill:#a16142}.prefix__st21{fill:none;stroke:#082e63;stroke-width:3.5221;stroke-linecap:round;stroke-linejoin:round;stroke-miterlimit:10}.prefix__st23{fill:#f2a619}.prefix__st25{fill:#006aff}.prefix__st26{fill:#0d4599}.prefix__st27{fill:#c88205}.prefix__st28{fill:#ffd237}.prefix__st30{fill:#8c551d}.prefix__st31{fill:#001751}.prefix__st32{clip-path:url(#prefix__m)}.prefix__st33{clip-path:url(#prefix__k);fill:#553213}'), /*#__PURE__*/React.createElement("switch", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__n",
  d: "M1.32.44h1920v1080H1.32z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__a"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__n"
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#prefix__a)",
  fill: "#e0f2ff",
  d: "M-247.18-4.86h2231v1088.7h-2231z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st1",
  d: "M-244.38-4.86h818.59v1088.7h-818.59z"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st3",
  d: "M347.4 962.23H-57.17V278.01H347.4v684.22zm-402.81-1.76h401.05v-680.7H-55.41v680.7z"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st3",
  d: "M310.41 962.23h-330.6V319.72h330.6v642.51zm-328.84-1.76h327.08V321.48H-18.43v638.99z"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__i",
  x1: 435.44,
  x2: 574.2,
  y1: 539.49,
  y2: 539.49,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#3DCDFD",
  stopOpacity: 0,
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#50E3FF",
  offset: 0.999
})), /*#__PURE__*/React.createElement("path", {
  opacity: 0.25,
  clipPath: "url(#prefix__a)",
  fill: "url(#prefix__i)",
  d: "M435.44-4.86H574.2v1088.7H435.44z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M1691.8 298.81h214.52v267.18H1691.8z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1880.5 533.62h-162.88V331.18h162.88v202.44zm-161.12-1.76h159.36V332.94h-159.36v198.92z",
  fill: "#a6e5ff"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st1",
  d: "M782.27 195.57h871.37v619.11H782.27z"
}), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#prefix__a)",
  fill: "#50e3ff",
  d: "M810.04 221.34h815.83V788.9H810.04z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1625.9 788.9V346.5c0-5.47-47.11-12.46-53.29-13.14a212.997 212.997 0 00-61.23 2.09c-55.55 10.04-92.79 48.27-132.23 81.5-55.54 46.78-123.64 56.15-196.29 56.15-132.81 0-115.22 180.85-372.79 180.85v134.97h815.83z",
  clipPath: "url(#prefix__a)",
  fill: "#001751"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__c",
  d: "M1625.9 788.9V346.5c0-5.47-47.11-12.46-53.29-13.14a212.997 212.997 0 00-61.23 2.09c-55.55 10.04-92.79 48.27-132.23 81.5-55.54 46.78-123.64 56.15-196.29 56.15-132.81 0-115.22 180.85-372.79 180.85v134.97h815.83z"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#001751",
  xlinkHref: "#prefix__c"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__h",
  d: "M810.04 221.34h815.83V788.9H810.04z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__b"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__h"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1784.2 738.31c3.19-56.75-41.9-287.25-190.71-249.5-47.94 12.16-90.99 61.96-112.18 91.25-53.58 74.04-86.58 234.51 30.09 291.18 59.66 28.98 148.28 18.99 202.03-14.91 49-30.91 68.27-73.41 70.77-118.02z",
  clipPath: "url(#prefix__b)",
  fill: "#006aff"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st11"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__g",
  d: "M1784.2 738.31c3.19-56.75-41.9-287.25-190.71-249.5-47.94 12.16-90.99 61.96-112.18 91.25-53.58 74.04-86.58 234.51 30.09 291.18 59.66 28.98 148.28 18.99 202.03-14.91 49-30.91 68.27-73.41 70.77-118.02z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__f"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__g"
})), /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#prefix__f)"
}, /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 779.39c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 741.45c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 703.52c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 665.59c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 627.65c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 589.72c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 551.79c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 513.86c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st13"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 475.92c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st14",
  d: "M507.01 437.99c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.31-14.09c21.66 0 21.66 14.09 43.31 14.09 21.66 0 21.66-14.09 43.32-14.09s21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.32-14.09 21.66 14.09 43.32 14.09 21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.32 14.09s21.66-14.09 43.33-14.09c21.66 0 21.66 14.09 43.33 14.09"
}))), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st11"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__e",
  d: "M1033 593.81c-12.13-50.32-44.32-94.02-56.54-144.31-11.46-47.12-5.17-99.01-27.36-142.14-19.88-38.64-41.12-49.81-84.5-49.46-43.38-.35-64.61 10.82-84.5 49.46-22.19 43.12-15.91 95.01-27.36 142.14-12.23 50.3-44.42 93.99-56.54 144.31-.36 1.49-.7 2.98-1.02 4.48-21.09 98.95 34.52 191.74 135.69 191.74h45.88c101.17 0 178.36-92.8 157.27-191.74-.32-1.5-.66-2.99-1.02-4.48z"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#F2A619",
  xlinkHref: "#prefix__e"
})), /*#__PURE__*/React.createElement("path", {
  d: "M1138.2 617.87c4.26-3.6 8.31-7.53 12.1-11.85 76.27-87-22.75-171.69-94.32-193.25-41.31-12.44-87.77-8.76-123.6 17.44s-58.21 77.04-48.34 123.72c3.82 18.04 12.1 34.35 23.13 48.15-3.16 1.77-6.26 3.65-9.31 5.64-48.53 31.64-78.85 93.03-65.47 149.4 9.67 40.75 40.34 74.29 77.46 94.03 3.05 1.62 6.15 3.15 9.28 4.59 41.21 18.87 87.95 22.6 133.15 19.17 51.33-3.89 104.65-18.2 140.74-54.9 78.34-79.66 20.15-157.71-54.82-202.14z",
  clipPath: "url(#prefix__b)",
  fill: "#fed036"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st11"
}, /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__d",
  d: "M1138.2 617.87c4.26-3.6 8.31-7.53 12.1-11.85 76.27-87-22.75-171.69-94.32-193.25-41.31-12.44-87.77-8.76-123.6 17.44s-58.21 77.04-48.34 123.72c3.82 18.04 12.1 34.35 23.13 48.15-3.16 1.77-6.26 3.65-9.31 5.64-48.53 31.64-78.85 93.03-65.47 149.4 9.67 40.75 40.34 74.29 77.46 94.03 3.05 1.62 6.15 3.15 9.28 4.59 41.21 18.87 87.95 22.6 133.15 19.17 51.33-3.89 104.65-18.2 140.74-54.9 78.34-79.66 20.15-157.71-54.82-202.14z"
})), /*#__PURE__*/React.createElement("use", {
  fill: "#FFD237",
  xlinkHref: "#prefix__d"
}))), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__s",
  d: "M810.04 221.34h815.83V788.9H810.04z"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st1",
  d: "M1211.9 220.22h23.61V788.9h-23.61z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__r",
  x1: 152.6,
  x2: 152.6,
  y1: 1083.8,
  y2: 954.58,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  stopOpacity: 0,
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0F2FA",
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  clipPath: "url(#prefix__a)",
  fill: "url(#prefix__r)",
  d: "M-247.18 954.58h799.57v129.27h-799.57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M705.39 677.93H187.45c-18.65 0-33.77 15.12-33.77 33.77v373.66h607.57V733.79c0-30.85-25.01-55.86-55.86-55.86z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M799.79 869.66H160.6v215.69h692.41V922.89c0-29.4-23.83-53.23-53.22-53.23z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__q",
  x1: 114.15,
  x2: 665.8,
  y1: 882.03,
  y2: 882.03,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0F2FF",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M612.57 678.32H146.32c-17.77 0-32.18 14.41-32.18 32.18v375.25H665.8v-354.2c0-29.4-23.83-53.23-53.23-53.23z",
  clipPath: "url(#prefix__a)",
  fill: "url(#prefix__q)"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__p",
  x1: 161.3,
  x2: 923.9,
  y1: 977.5,
  y2: 977.5,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#E0F2FF",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#fff",
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M868.04 869.66H161.3v215.69h762.6V925.52c0-30.85-25.01-55.86-55.86-55.86z",
  clipPath: "url(#prefix__a)",
  fill: "url(#prefix__p)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M895.18 936.75h713.29v49.2H895.18z"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M82.23 605.39c-5.41-6.83-14.48-10.93-23.12-9.35-12.61 2.31-21.79 16.26-18.91 28.75-5.83-28.37-11.67-56.74-17.5-85.13-2.04-9.93-6.98-27.36-19.99-26.75-40.12 1.9-29.09 72.57-26.11 97.41-1-8.29-7.63-16.19-15.7-18.38-9.97-2.71-21.52 3.06-25.35 12.65-4.22 10.55.6 22.66 7.46 31.72s15.79 16.56 21.54 26.36c11.11 18.9 8.55 42.4 8.08 64.32s3.22 46.97 21.4 59.21c17.65 11.88 42.71 6.12 58.92-7.65s25.6-33.74 34.36-53.13c3.64-8.05 7.3-16.32 7.96-25.13s-2.27-18.42-9.52-23.47c-7.25-5.06-19.01-3.47-22.91 4.45-3.81-23.4 27.33-41.52 24.13-65.02-.54-4.01-2.25-7.72-4.74-10.86z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M95.36 765.28H-37.8l19.01 103.61h88.8z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st25",
  d: "M17.49 890.54l-55.29 193.07H95.36L40.07 890.54c-3.25-11.35-19.33-11.35-22.58 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st26",
  d: "M20.62 879.58l-25.49 89a2.39 2.39 0 002.3 3.05h62.69a2.39 2.39 0 002.3-3.05l-25.49-89c-2.34-8.19-13.96-8.19-16.31 0z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st25",
  d: "M133.82 869.2H-70.87v29.33c0 34.7 28.13 62.82 62.82 62.82h79.04c34.7 0 62.82-28.13 62.82-62.82V869.2z"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st1",
  d: "M1691.8 556.41h214.52v40.43H1691.8z"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st27",
  d: "M1010 985.95h-57.33v97.85h24.49zM1492.8 985.95h57.2v97.85h-24.4z"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st28",
  d: "M1938.7 725.14c-3.76-11.05-17.41-14.12-28.27-11.95s-21.25 7.77-32.3 7.35c-5.22-.2-10.88-2.17-13.52-6.97-3.47-6.3-.33-14.32 3.46-20.4 7.17-11.49 16.63-21.17 24.3-32.29s13.66-24.55 12.27-38.26c-.52-5.15-2.4-10.22-5.23-14.51-5.28-9.05-16.91-14.16-27.09-11.4-5.87 1.59-11.05 5.88-14.29 11.23-.81.7-1.66 1.37-2.45 2.1 4.02-32.4 11.36-100.21-30.26-102.17-14.63-.68-20.18 18.91-22.48 30.08-6.56 31.91-13.12 63.8-19.67 95.7 3.24-14.05-7.08-29.73-21.26-32.32-9.71-1.78-19.91 2.84-25.99 10.51-2.8 3.53-4.72 7.7-5.33 12.2-3.57 26.23 30.93 46.51 27.19 72.57-.07.1-.13.2-.2.3-4.5-8.7-17.55-10.41-25.62-4.78-8.15 5.68-11.44 16.48-10.7 26.38s4.86 19.2 8.95 28.25c6.13 13.57 12.54 27.4 20.9 39.64.3 2.4.58 4.59.81 6.53-1.12-9.32-8.58-18.2-17.65-20.66-11.21-3.04-24.19 3.44-28.5 14.22-4.74 11.86.68 25.47 8.39 35.66 7.71 10.18 17.75 18.62 24.22 29.63 12.49 21.25 9.61 47.67 9.08 72.31s3.61 52.8 24.06 66.56c19.84 13.35 48.01 6.88 66.24-8.6s28.78-37.94 38.62-59.73c4.09-9.05 8.21-18.35 8.95-28.25s-2.55-20.7-10.7-26.38-21.37-3.91-25.76 5.01c-.36-2.21-.42-4.38-.27-6.52 11.5-21.98 25.88-42.26 42.65-60 19.21-20.32 42.83-39.71 47.82-68.02.76-4.34 1.03-8.89-.37-13.02z"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M1908.9 930.63h-196.6l28.1 152.97h131.1z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M1109.9 882.03H960.17v19.46c0 19.48 15.79 35.27 35.27 35.27h79.2c19.48 0 35.27-15.79 35.27-35.27v-19.46z",
  clipPath: "url(#prefix__a)",
  fill: "#006aff"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M208.47 677.93H191.7c-21 0-38.02 17.02-38.02 38.02v369.4h92.82v-369.4c0-21-17.03-38.02-38.03-38.02z"
}), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st2"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st30",
  d: "M380.1 664.82c-1.58-16.08-.33-32.23 8.62-44.53 8.25-11.34 20.74-11.61 30.6-1.94 17.64 17.31-8.02 31.19-12.6 43.41.68 1.45-3.55 36.61-2.94 38.08l-21.79-.71-1.89-34.31z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st26",
  d: "M281.06 706.58c14.36 9.29 28.96 17.64 44.04 23.92 7.55 3.11 30.77 9.77 34.78 10.53 4.02.77 10.17.77 10.66-.95.5-1.71 2.83-13.49 3.43-17.75.59-4.26 3.73-44.91 4.41-54.2l30.12-1.6c1.66 9.39 2.94 18.85 4.03 28.46.5 4.81 1.87 24.43 1.96 29.51.11 5.08-.9 21.16-1.32 24.03s-.92 5.83-1.74 8.96c-.81 3.13-1.83 6.42-3.38 9.98 0 0-1.72 3.59-2.03 4.13-.38.66-4.88 6.9-7.17 8.99-4.57 4.18-10.22 7.23-16.31 8.69-3.04.74-6.18 1.09-9.3 1.03 0 0-14.75-.59-20-1.1-5.26-.49-10.56-1.22-15.8-2.2-10.5-1.93-69.05-25.08-85.79-36.54l29.41-43.89z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st31",
  d: "M431.32 583.12l-20.08.65c-4.95.25-9.15 3.73-10.3 8.55l-13.29 55.31c-.83 3.47 1.9 6.76 5.46 6.58l23.01-.8a7.242 7.242 0 006.68-5.55l13.97-58.17c.85-3.46-1.89-6.75-5.45-6.57z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st30",
  d: "M383.81 641.94s2.4-12.77 9.73-13.95 17.42.52 16.67 5.53c-.76 5.06-11.27 8.73-19.74 6.13"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st31",
  d: "M511.5 865.28a40.677 40.677 0 00-7.99-2.53l.02-.08c-38.98-10.24-167.53-29.04-184.85-29.85-17.33-.81-41.27.03-47.35 32.18-12.01 63.47 143.07 52.11 206.43 44.4 54.09 27.36 189.16 60.12 189.16 60.12l4.14-27.25c-39.31-22.53-123.81-61.45-159.56-76.99zM304.5 589.57c-3.47-6.2-11.62-9.39-18.21-7.53 7.64-6.32 8.95-20.24.9-26.72-6.38-5.13-16.07-3.52-22.08 1.74 1.09-7.32-1.88-15.57-8.02-20.02-9.42-6.82-23.3-5.13-32.47 2.03-9.17 7.17-14.08 18.71-15.63 30.24-1.14 8.52-.65 17.12.27 25.69-2.1-5.82-6.76-10.77-12.66-12.71-18.63-6.14-28.53 11.15-25.1 26.67 3.62 16.38 15.73 31.1 31.74 36.61-13.39-1.61-26.03 12.83-22.65 25.89s21.42 19.57 32.36 11.67c-7.24 8.93 2.21 24.05 13.7 23.93 11.49-.11 20.54-11.53 21.28-23 .75-11.47-4.92-22.45-12.01-31.49 8.89 3.85 20.52-1.08 23.94-10.15s-2.05-20.44-11.27-23.43c8.72 2.42 17.59 4.75 26.64 4.68 9.05-.06 18.42-2.79 24.78-9.22 6.36-6.42 8.91-16.98 4.49-24.88z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M423.02 777.12l23.78-18.74 17.45 50.55c2.58 7.46-1.39 15.6-8.85 18.18s-15.6-1.39-18.18-8.85l-14.2-41.14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st28",
  d: "M407.91 745.89s-46.27-2.38-65.89 26.98 8.94 75.47 8.94 75.47l72.19-42.81v.01l19.02-37.37-34.26-22.28z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__o",
  d: "M407.91 745.89s-46.27-2.38-65.89 26.98 8.94 75.47 8.94 75.47l72.19-42.81v.01l19.02-37.37-34.26-22.28z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__m"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__o"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st32"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M343.39 763.37a27.33 27.33 0 015.63 15.07c.28 5.08-.81 10.48 1.39 15.07 1.65 3.43 6.68 6.22 10.39 6.44 6.14.35 7.53-7.3 9.33-11.65 1.8-4.34 5.24-6.63 9.76-7.42 4.18-.73 9.75 1.24 12.36-3.17 6.65-11.24-6.69-26.63-10.07-36.94"
})), /*#__PURE__*/React.createElement("g", {
  className: "prefix__st32"
}, /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M391.89 830.1c-4.72-5.26-9.65-10.95-10.64-17.95-.64-4.56 2.43-6.29 5.08-9.22 4.19-4.63 2.97-10.21 5.9-15.05 1.67-2.76 5.21-4.17 8.36-3.49 4.42.96 5.79 4.96 6.75 8.86 1.27 5.14 2.35 7.95 5.87 12 1.9 2.18 3.56 5.03 2.83 7.83"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st28",
  d: "M386.69 718.23c.56-.57 1.38-.79 2.15-.56 7.17 2.2 14.48 6.25 22.17 6.04 9.32-.25 19.31-4.95 27.36-9.29 7.24-3.9 10.27-11.67 15.02-18.19.47-.65 1.27-.97 2.06-.84.78.13 1.44.68 1.69 1.44 4.81 14.49 10.86 29.09 14.58 43.89 2.71 10.77-1.97 22.37-13.09 26.07l-31.8 10.56c-10.79 3.58-22.49-2.28-26.07-13.07L386.2 720.4c-.26-.76-.07-1.6.49-2.17z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st31",
  d: "M315.85 835.25c-15 8.72-34.66 22.4-22.34 52.71 25.21 62.02 180.06-44.1 211.31-73.28 40.06 30.38 154.4 85.17 154.4 85.17 4.66 1.89 10-.02 12.41-4.43 8.59-15.73-14.66-31.61-14.66-31.61-33.69-30.3-96.04-75.89-127.72-98.62-12.18-8.74-27.64-9.75-41.89-5.08-38.3 12.53-156.52 66.43-171.51 75.14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st30",
  d: "M312.34 641.14c-2.45-2.54-7.15-5.19-9.31-12.69-2.15-7.5-4.29-14.91-4.29-14.91-7.82-27.11-33.25-41.32-57.52-34.33s-38.41 31.9-30.59 59.01c4.85 16.81 17 19.12 24.89 32.03 10.78 17.64 5.45 60.52 5.45 60.52l51.25-6.58-9.64-28.61c-3.11-9.61 3.16-11.08 7.35-12.29 3.11-.89 6.31-1.81 9.64-2.78 6.18-1.78 10.36-6.05 8.8-15.92l-1.56-11.63a4.764 4.764 0 013.41-5.22l.31-.09c3.32-.97 4.25-3.98 1.81-6.51z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st31",
  d: "M240.36 579.31c-24.66 7.05-39.07 31.98-31.19 59.09 4.89 16.81 17.23 19.09 25.21 31.99 3.03 4.89 3.75 10.11 4.84 15.37.39 1.87 1.12 3.66 2.15 5.27l11.69-25.22s-13.49 9.62-17.69-12.88c-3.42-18.33 10.73-22.3 20.26-4.76.72 1.32 2.66 1.26 3.23-.13 8.26-20.25 56.61-33.13 33.72-57.7-16.53-17.76-42-13.95-52.22-11.03z"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "prefix__l",
  d: "M312.34 641.14c-2.45-2.54-7.15-5.19-9.31-12.69-2.15-7.5-4.29-14.91-4.29-14.91-7.82-27.11-33.25-41.32-57.52-34.33s-38.41 31.9-30.59 59.01c4.85 16.81 17 19.12 24.89 32.03 10.78 17.64 5.45 60.52 5.45 60.52l51.25-6.58-9.64-28.61c-3.11-9.61 3.16-11.08 7.35-12.29 3.11-.89 6.31-1.81 9.64-2.78 6.18-1.78 10.36-6.05 8.8-15.92l-1.56-11.63a4.764 4.764 0 013.41-5.22l.31-.09c3.32-.97 4.25-3.98 1.81-6.51z"
})), /*#__PURE__*/React.createElement("clipPath", {
  id: "prefix__k"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#prefix__l"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st33",
  d: "M289.65 691.83c-1.21-.12-2.42-.2-3.62-.37l-1.8-.32-.89-.16-.89-.23-1.76-.47c-.58-.19-1.15-.41-1.72-.61l-.85-.31-.83-.38c-.55-.26-1.11-.49-1.65-.78a28.915 28.915 0 01-5.95-4.11c-.9-.79-1.73-1.67-2.51-2.58-.78-.96-1.46-1.84-2.14-3.05a1.71 1.71 0 01.65-2.34c.75-.42 1.69-.22 2.2.44l.11.14c.51.66 1.27 1.46 2 2.12.76.67 1.55 1.31 2.39 1.86 1.68 1.13 3.48 2.04 5.37 2.71.47.17.96.29 1.43.44l.71.21.74.15c.49.1.97.21 1.46.3l1.49.18.74.09.75.03 1.49.06c1 0 2.01-.08 3-.11l.32-.01c1.96-.06 3.6 1.49 3.66 3.45s-1.49 3.6-3.45 3.66c-.14.02-.31.01-.45-.01zM311.3 651.08l-8.4.34a1.03 1.03 0 01-1.07-.99c-.02-.51.33-.94.81-1.05l8.21-1.79c.95-.21 1.9.4 2.1 1.35.21.95-.4 1.9-1.35 2.1-.09.02-.2.04-.3.04z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M242.99 643.04c.37-.07.55-.11.8-.14.24-.03.47-.04.7-.04.46-.01.92.03 1.38.11.91.15 1.78.48 2.59.91 1.63.87 2.88 2.24 3.77 3.66.51.7.78 1.47 1.14 2.21.28.75.5 1.52.69 2.29.12.77.27 1.53.31 2.3.01.76.02 1.52-.05 2.28-.1.99-.98 1.72-1.97 1.62-.65-.06-1.18-.46-1.45-1l-.08-.17c-.3-.62-.52-1.25-.74-1.86-.23-.61-.48-1.19-.69-1.78l-.72-1.67c-.27-.51-.51-1.05-.8-1.5-.56-.95-1.2-1.76-1.95-2.37-.39-.28-.78-.6-1.22-.8-.21-.13-.45-.21-.68-.31-.11-.04-.23-.09-.34-.12-.1-.05-.27-.07-.25-.12-.96.12-1.85-.56-1.97-1.52a1.79 1.79 0 011.53-1.98z",
  fill: "#553213"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st25",
  d: "M226.21 745.67c.46-18.08 6.91-36.53 24.61-40.24 9.79-2.05 81.46 1.64 77.65 40.24-5.48 40.76 27.74 59.22 31.6 93.92-7.38 0-108.8 53.31-108.8 53.31s-27.12-67.28-25.06-147.23z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st28",
  d: "M408.27 780.18l23.78-18.74 17.45 50.55c2.58 7.46-1.39 15.6-8.85 18.18s-15.6-1.39-18.18-8.85l-14.2-41.14z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st30",
  d: "M360.76 831.5c15.89-2.93 32.08-3.06 45.1 4.82 12 7.26 13.32 19.69 4.52 30.32-15.75 19.04-31.76-5.35-44.32-8.88-1.38.8-36.78-.44-38.2.29l-1.14-21.77 34.04-4.78z"
}), /*#__PURE__*/React.createElement("linearGradient", {
  id: "prefix__j",
  x1: 303.77,
  x2: 303.77,
  y1: 865.21,
  y2: 723.77,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D4599",
  offset: 0
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#0D4599",
  stopOpacity: 0.97,
  offset: 0.536
}), /*#__PURE__*/React.createElement("stop", {
  stopColor: "#105FD6",
  stopOpacity: 0,
  offset: 1
})), /*#__PURE__*/React.createElement("path", {
  d: "M296.9 730.17c-.02.85-1.3 19.8-1.56 23.78l-1.99 23.71s-1.42 19.27-1.56 22.94c-.12 3.67-.24 7.25-.23 10.48 0 1.61 17.56 6.58 25.32 8.51 3.89.96 19.65 4.51 23.63 5.33 7.96 1.83 15.99 3.37 24.15 5.26l1.41 28.95c-17.56 1.3-34.9 1.38-52.32.51-8.73-.45-17.44-1.14-26.45-2.3-4.54-.6-9.06-1.27-14.25-2.42-1.32-.3-2.68-.63-4.21-1.06-1.55-.46-7.15-2.68-7.15-2.68s-3.07-1.73-3.62-2.1c-.71-.49-1.51-1.09-2.24-1.7-.54-.46-1.06-.95-1.56-1.45l-1.73-1.93c-.69-.85-2.73-4.11-2.73-4.11s-1.52-2.98-1.74-3.49c-.43-1.01-.87-2.08-1.18-2.96-1.32-3.71-2.01-6.72-2.58-9.52-.56-2.8-.94-5.39-1.26-7.89-.62-4.99-.96-9.66-1.18-14.23-.44-9.12-.45-17.87-.28-26.55.17-8.66 2.88-51.47 2.88-51.47l52.43 6.39z",
  fill: "url(#prefix__j)"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M685.9 984.01c4.02 1.51 8.53-.22 10.49-4.04 7-13.6 22.66-44.1 27.95-54.94 8.79-17.65-41.12 28.28-41.12 28.28-8.63-7.38-17.17-14.58-25.84-21.35-.57-.44-1.41-.21-1.67.46l-12.95 32.92c-.21.54.05 1.16.59 1.39 23.96 10.14 42.55 17.28 42.55 17.28z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M688.87 986.31c-1.2 0-2.41-.21-3.6-.66h-.01c-.19-.07-18.88-7.27-42.6-17.29-1.41-.6-2.1-2.24-1.54-3.66l12.95-32.92c.33-.83 1.04-1.47 1.9-1.7.87-.24 1.78-.06 2.5.5 8.47 6.6 16.86 13.67 24.72 20.38 2.84-2.59 10.52-9.51 18.41-16.15 21.05-17.69 23.07-16.17 24.55-15.06 2.04 1.53.46 4.71-.21 6.06-5.35 10.95-21.34 42.08-27.96 54.96a10.279 10.279 0 01-9.11 5.54zM672.22 913.8a8.464 8.464 0 0011.11-1.74c9.7-11.82 31.42-38.35 38.88-47.83 12.31-15.41-46.15 19-46.15 19-6.89-9.04-13.73-17.89-20.8-26.34-.45-.54-1.29-.49-1.68.1l-19.62 29.53c-.31.47-.19 1.11.28 1.44 21.3 14.94 37.98 25.84 37.98 25.84z"
}), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st23",
  d: "M676.79 916.91c-1.9 0-3.82-.53-5.52-1.62l-.01-.01c-.17-.11-16.95-11.08-38.04-25.88-1.24-.87-1.57-2.6-.73-3.85l19.62-29.53c.49-.74 1.31-1.2 2.19-1.25.9-.04 1.73.32 2.31 1 6.9 8.25 13.63 16.93 19.91 25.16 3.32-1.93 12.28-7.09 21.39-11.92 24.3-12.87 25.96-10.96 27.17-9.56 1.67 1.93-.54 4.7-1.49 5.88-7.52 9.57-29.71 36.65-38.9 47.85-2 2.44-4.93 3.73-7.9 3.73z"
})), /*#__PURE__*/React.createElement("path", {
  className: "prefix__st6",
  d: "M329.04 869.66H153.68v215.69h238.74V933.04c0-35-28.38-63.38-63.38-63.38z"
})))));

var _templateObject$9, _templateObject2$5, _templateObject3$1;
var DuplicateModalDialog = styled(StyledModalDialog)(_templateObject$9 || (_templateObject$9 = _taggedTemplateLiteral(["\n    ", " {\n        overflow: hidden;\n\n        ", " {\n            padding: 0;\n        }\n\n        ", " {\n            ", "\n        }\n    }\n"])), StyledDialog, DialogHeader, DialogBody, mediaMixin('md', css(["padding:24px 0 0;max-height:332px;min-height:332px;"])));
var StyledDuplicateOfferRequestHeaderWrapper = styled.div(_templateObject2$5 || (_templateObject2$5 = _taggedTemplateLiteral(["\n    height: 280px;\n    overflow: hidden;\n    display: flex;\n    flex-direction: column;\n    justify-content: flex-end;\n    ", "\n"])), mediaMixin('md', css(["height:243px;"])));
var StyledDuplicateOfferRequestHeaderInnerWrapper = styled.div(_templateObject3$1 || (_templateObject3$1 = _taggedTemplateLiteral(["\n    /* There is small white space at the bottom, not sure why that is */\n    margin-bottom: -4px;\n\n    /* Increase the width of the svg container allow zooming in the svg center without having to change the viewbox. */\n    width: 200%;\n    flex-grow: 1;\n    ", "\n\n    /* IE10 + IE11 filter, there isn't an easy way to make the svg work in IE 11 without specific style */\n    @media all and (-ms-high-contrast: none), (-ms-high-contrast: active) {\n        /* This is a hack so that the svg height can overflow outside of the container box, this allow its width to increase and cover the dialog header */\n        margin-top: -160px;\n        height: 420px;\n    }\n"])), mediaMixin('md', css(["width:100%;"])));

var DuplicateOfferRequestHeader = () => /*#__PURE__*/React.createElement(StyledDuplicateOfferRequestHeaderWrapper, null, /*#__PURE__*/React.createElement(StyledDuplicateOfferRequestHeaderInnerWrapper, null, /*#__PURE__*/React.createElement(DuplicateOfferRequestBackground, null)));

var trackCloseClick = () => {
  trackOffersEvent({
    action: 'InProgress',
    label: 'Close'
  });
};

var trackDashboardClick = () => {
  trackOffersEvent({
    action: 'InProgress',
    label: 'dashboard-entry Submit'
  });
};

var trackUserOwnErrorDisplay = () => {
  trackOffersEvent({
    action: 'InProgress',
    label: 'dashboard-entry Display'
  });
};

var trackErrorDisplay = () => {
  trackOffersEvent({
    action: 'InProgress',
    label: 'error Display'
  });
};

var DuplicateErrorDialog = _ref => {
  var {
    address,
    errorMessage,
    dashboardUrl,
    onClose,
    isOpen
  } = _ref;
  useEffect(() => {
    if (dashboardUrl) {
      trackUserOwnErrorDisplay();
    } else {
      trackErrorDisplay();
    }
  }, [dashboardUrl]);
  var message;
  var primaryButton;

  if (dashboardUrl) {
    message = address || '';
    primaryButton = /*#__PURE__*/React.createElement(Button, {
      marginTop: "xl",
      as: "a",
      href: dashboardUrl,
      fluid: true,
      buttonType: "primary",
      "data-testid": "submit-btn",
      onClick: () => {
        trackDashboardClick();
      }
    }, "View your dashboard");
  } else {
    message = errorMessage;
    primaryButton = /*#__PURE__*/React.createElement(Button, {
      marginTop: "xl",
      style: {
        width: '186px'
      },
      fluid: true,
      buttonType: "primary",
      "data-testid": "close-btn",
      onClick: () => {
        trackCloseClick();
        onClose();
      }
    }, "Close");
  }

  return /*#__PURE__*/React.createElement(DuplicateModalDialog, {
    header: /*#__PURE__*/React.createElement(DuplicateOfferRequestHeader, null),
    body: /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Paragraph, {
      as: "h2",
      mediaQuery: {
        md: {
          fontType: 'h3'
        }
      },
      marginTop: "md",
      fontType: "h4",
      fontFamily: "serif",
      style: {
        margin: 'auto',
        maxWidth: '300px'
      }
    }, "There is an offer request in progress"), /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "sm"
    }, message), primaryButton),
    onClose: onClose,
    isOpen: isOpen
  });
};

DuplicateErrorDialog.defaultProps = {
  address: null,
  dashboardUrl: null,
  errorMessage: null,
  isOpen: false,
  onClose: () => {}
};

var img = "data:image/jpeg;base64,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";

var _templateObject$a;
var CatHeaderImage = styled.div(_templateObject$a || (_templateObject$a = _taggedTemplateLiteral(["\n    background: url(", ") no-repeat center;\n    background-size: contain;\n    height: 208px;\n"])), img);

var GenericErrorDialog = _ref => {
  var {
    errorMessage,
    onClose,
    isOpen
  } = _ref;
  return /*#__PURE__*/React.createElement(StyledModalDialog, {
    body: /*#__PURE__*/React.createElement("div", {
      style: {
        textAlign: 'center'
      }
    }, /*#__PURE__*/React.createElement(Spacer, {
      marginTop: "md"
    }), /*#__PURE__*/React.createElement(CatHeaderImage, null), /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "md",
      fontType: "h4"
    }, "Uh oh,", /*#__PURE__*/React.createElement("br", null), "something went wrong."), /*#__PURE__*/React.createElement(Paragraph, {
      marginTop: "sm",
      marginBottom: "xl"
    }, errorMessage), /*#__PURE__*/React.createElement(Spacer, {
      style: {
        margin: 'auto',
        width: '186px'
      }
    }, /*#__PURE__*/React.createElement(Button, {
      fluid: true,
      buttonType: "primary",
      onClick: onClose,
      "data-testid": "close-btn"
    }, "Close"))),
    onClose: onClose,
    isOpen: isOpen
  });
};

GenericErrorDialog.defaultProps = {
  errorMessage: null,
  isOpen: false,
  onClose: () => {}
};

function _taggedTemplateLiteral$1(strings, raw) {
  if (!raw) {
    raw = strings.slice(0);
  }

  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var _templateObject$b, _templateObject2$6, _templateObject3$2;

var StyleWrapper$3 = styled.div(_templateObject$b || (_templateObject$b = _taggedTemplateLiteral$1(["\n    background: ", ";\n    border-radius: 8px;\n    display: flex;\n    flex-direction: row;\n    text-align: left;\n    align-items: center;\n    margin-bottom: ", ";\n    height: 84px;\n    font-family: 'Open Sans', Tahoma, Geneva, sans-serif;\n"])), token('colors.coolGray100'), spaceMixin('xs'));
var StyledTextButton = styled(TextButton)(_templateObject2$6 || (_templateObject2$6 = _taggedTemplateLiteral$1(["\n    text-align: left;\n    color: ", ";\n    text-decoration: none;\n    font-weight: 700;\n\n    :hover {\n        text-decoration: underline;\n    }\n"])), token('colors.blue500'));
var StyledIconSpacer = styled(Spacer)(_templateObject3$2 || (_templateObject3$2 = _taggedTemplateLiteral$1(["\n    margin: ", ";\n    ", "\n"])), spaceMixin('md'), mediaMixin('lg', css(["margin-left:", ";margin-right:", ";"], spaceMixin('xl'), spaceMixin('xl'))));

var OptionsCard = _ref => {
  var {
    Icon,
    onClick,
    title,
    urlText,
    url
  } = _ref;
  return /*#__PURE__*/React.createElement(ThemeProvider, {
    theme: ThemeConstellation
  }, /*#__PURE__*/React.createElement(StyleWrapper$3, null, /*#__PURE__*/React.createElement(StyledIconSpacer, null, /*#__PURE__*/React.createElement(Icon, null)), /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(Paragraph, null, title), /*#__PURE__*/React.createElement(StyledTextButton, {
    as: "a",
    href: url,
    onClick: onClick
  }, urlText))));
};

var _templateObject$1$1, _templateObject2$1$1, _templateObject3$1$1;

var Handshake = function Handshake(props) {
  return /*#__PURE__*/createElement("svg", props, /*#__PURE__*/createElement("path", {
    d: "M35.243 18.708l-3.655-3.656c-.01-.009-.02-.015-.029-.024-.009-.009-.015-.02-.024-.029l-6.29-6.291a3.964 3.964 0 0 0-5.59 0l-.86.861-4.985-4.983a2 2 0 0 0-2.827 0l-5.4 5.4a2 2 0 0 0 0 2.827l4.991 4.987a3.96 3.96 0 0 0 .048 5.531l6.291 6.291c.01.01.02.015.03.024.008.01.014.02.023.03l3.655 3.654a2.585 2.585 0 0 0 3.656-3.655 2.585 2.585 0 1 0 3.655-3.656 2.585 2.585 0 0 0 3.656-3.655 2.584 2.584 0 1 0 3.655-3.655v-.001z",
    fill: "#A6E5FF"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.275 35.976l-.1-.1a.036.036 0 0 0 .023.012h.012c0 .011 0 .011.011.022l.023.023c.008.009.02.032.031.043zM10.856 18.31l-2.363 2.363v-.01l2.363-2.353zM22.82 28.444a2.49 2.49 0 0 1-.183.386h-.01c.07-.125.135-.254.192-.386zM23.705 29.546v.011a2.454 2.454 0 0 0-.25-.227c.088.066.172.138.25.216z",
    fill: "#006AFF"
  }), /*#__PURE__*/createElement("path", {
    d: "M17.2 35.886a.036.036 0 0 1-.023-.012 3.004 3.004 0 0 1-.227-.3c.074.11.158.215.25.312zM17.218 35.908l-.023-.022h.012c0 .014 0 .014.011.022z",
    fill: "#006AFF"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40 13.658a4.53 4.53 0 0 1-1.332 3.208l-2.62 2.62a4.541 4.541 0 0 1-1.726 1.074l2.131 2.137a3.858 3.858 0 0 1 0 5.42 3.756 3.756 0 0 1-2.505 1.111 3.82 3.82 0 0 1-1.112 2.506 3.706 3.706 0 0 1-2.5 1.112 3.813 3.813 0 0 1-3.617 3.617 3.7 3.7 0 0 1-1.112 2.505 3.834 3.834 0 0 1-5.419 0l-3.425-3.426-.077-.076-.02-.026c-.006-.01-.012-.019-.018-.025l-.026-.026c-.007-.007-.01-.01-.012-.014a.021.021 0 0 1 0-.008v-.004h-.013a2.5 2.5 0 0 1-.282-.345c-.228-.3-.4-.639-.51-1a2.721 2.721 0 0 1-.14-.536 2.43 2.43 0 0 1-.078-.524 3.787 3.787 0 0 1-3.617-3.618 3.811 3.811 0 0 1-3.617-3.617 3.138 3.138 0 0 1-.358-.038 3.731 3.731 0 0 1-2.147-1.06 3.832 3.832 0 0 1-.729-4.385 4.525 4.525 0 0 1 .205-6.173l5.33-5.33a4.529 4.529 0 0 1 6.415 0l.537.537c.205-.383.468-.732.78-1.035l1.8-1.815a5.156 5.156 0 0 1 7.234 0l.895.907.41-.409a4.553 4.553 0 0 1 6.415 0l3.528 3.528A4.529 4.529 0 0 1 40 13.658zM8.56 23.18c.34.002.667-.131.908-.37l.892-.895 2.71-2.723a1.273 1.273 0 0 0 0-1.8 1.28 1.28 0 0 0-1.8 0l-2.71 2.71-.907.907a1.272 1.272 0 0 0 .907 2.171zm3.612 3.62a1.233 1.233 0 0 1-.907-.37 1.272 1.272 0 0 1 0-1.8l3.617-3.618 1.8-1.815a1.3 1.3 0 0 1 1.815 0 1.3 1.3 0 0 1 0 1.815l-1.71 1.708a.618.618 0 0 0-.1.09l-3.618 3.616c-.235.243-.56.378-.897.374zm2.723 3.222c.49.494 1.286.505 1.79.024l1.815-1.822 1.8-1.8a1.272 1.272 0 0 0 0-1.8 1.251 1.251 0 0 0-1.8 0l-3.616 3.608c-.484.5-.48 1.296.01 1.79zm4.5 4.012a1.278 1.278 0 0 1-.896-2.185l1.8-1.8c.24-.24.568-.374.908-.37.336-.004.66.13.894.37a1.252 1.252 0 0 1 0 1.8l-1.8 1.815a1.29 1.29 0 0 1-.907.367v.003zm2.59 3.13a1.314 1.314 0 0 0 1.815 0c.501-.5.505-1.312.007-1.816a1.245 1.245 0 0 1-.345-1.087 1.15 1.15 0 0 1 .026-.097c.01-.031.019-.063.025-.094H23.5l-1.4 1.393a3.794 3.794 0 0 1-1.06.741l.945.96zm12.657-12.655a1.275 1.275 0 0 1-1.8 1.8 1.275 1.275 0 1 0-1.8 1.8 1.311 1.311 0 0 1 0 1.814c-.502.5-1.313.5-1.815 0a1.275 1.275 0 0 0-1.8 1.8 1.283 1.283 0 1 1-1.815 1.815 1.255 1.255 0 0 0-1.355-.282c.13-.166.242-.346.333-.536a5.04 5.04 0 0 0 .332-.882c.028-.1.049-.203.064-.307a3.787 3.787 0 0 0-1.061-3.298 2.62 2.62 0 0 0-.28-.255 3.137 3.137 0 0 0-.55-.37 1.998 1.998 0 0 0-.37-.193H22.7c.08-.14.153-.285.217-.434.069-.153.124-.31.166-.473.045-.16.079-.322.1-.486a3.51 3.51 0 0 0 0-1.022 3.17 3.17 0 0 0-.128-.6 3.261 3.261 0 0 0-.28-.69 6.938 6.938 0 0 0-.193-.32 4.303 4.303 0 0 0-.486-.588 3.617 3.617 0 0 0-1.2-.8 3.811 3.811 0 0 0-5.215-5.215c-.024-.047-.048-.098-.072-.15a3.862 3.862 0 0 0-.481-.783c-.044-.044-.086-.09-.127-.134-.042-.045-.083-.09-.128-.134a3.712 3.712 0 0 0-1.598-.959 3.592 3.592 0 0 0-.358-.089 3.688 3.688 0 0 0-.754-.077 3.773 3.773 0 0 0-2.709 1.125L6.8 18.246v-.012a1.98 1.98 0 0 1 .32-2.365l5.33-5.33a1.984 1.984 0 0 1 2.811 0l1.653 1.661a4.985 4.985 0 0 0 1.431 3.223c.01.012.021.027.04.036a5.032 5.032 0 0 0 6.2.78 4.81 4.81 0 0 0 1.008-.78l9.05 9.05zm-3.314-6.94a2.123 2.123 0 0 0 2.914.115l2.623-2.618a2.006 2.006 0 0 0 0-2.812L33.338 8.74a1.968 1.968 0 0 0-2.8 0l-.818.8a1.967 1.967 0 0 1-2.8 0l-1.317-1.3a2.567 2.567 0 0 0-.843-.563 2.5 2.5 0 0 0-1.917 0c-.32.13-.611.32-.857.563l-1.8 1.8a2.584 2.584 0 0 0 0 3.617c.081.078.171.147.268.205a2.4 2.4 0 0 0 1.534.536c.203.008.406-.018.6-.076a2.394 2.394 0 0 0 1.214-.665l1.8-1.8 5.726 5.713z",
    fill: "#0D4599"
  }), /*#__PURE__*/createElement("path", {
    d: "M38.482 29.165v.018A4.152 4.152 0 0 1 35.55 32.1h-.018a.227.227 0 0 0 0 .442h.018a4.152 4.152 0 0 1 2.933 2.914v.018a.2.2 0 0 0 .393 0v-.018a4.149 4.149 0 0 1 2.932-2.914h.018a.227.227 0 0 0 0-.442h-.018a4.149 4.149 0 0 1-2.932-2.914v-.018a.2.2 0 0 0-.393 0v-.003zM3.975 29.1v.01a2.39 2.39 0 0 1-1.688 1.678h-.01a.13.13 0 0 0 0 .254h.01a2.39 2.39 0 0 1 1.688 1.678v.01a.115.115 0 0 0 .226 0v-.01a2.388 2.388 0 0 1 1.688-1.678H5.9a.13.13 0 0 0 0-.254h-.01a2.388 2.388 0 0 1-1.69-1.683V29.1a.115.115 0 0 0-.132-.1.113.113 0 0 0-.093.1z",
    fill: "#F2A619"
  }));
};

Handshake.defaultProps = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var Painter = function Painter(props) {
  return /*#__PURE__*/createElement("svg", props, /*#__PURE__*/createElement("path", {
    d: "M41 9a.78.78 0 0 0-.084.017c-.029 0-.054-.017-.084-.017H13.168c-.03 0-.055.015-.084.017A.78.78 0 0 0 13 9a1 1 0 0 0-1 1v15a1 1 0 0 0 1 1h20a1.007 1.007 0 0 0 1-1v-2a1 1 0 1 1 2 0v4a1 1 0 1 0 2 0v-4a1 1 0 1 1 2 0v6a1 1 0 1 0 2 0V10a1 1 0 0 0-1-1z",
    fill: "#A6E5FF"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20 34.343l.861-7.354a1.294 1.294 0 0 1 1.286-1.132h2.134a1.293 1.293 0 0 1 1.286 1.132l.862 7.354a3.217 3.217 0 0 1-6.429 0zm4.373-1.263c-.2-.481-.672-.794-1.193-.791v-.003a1.288 1.288 0 0 0-.488 2.477 1.286 1.286 0 0 0 1.68-1.683z",
    fill: "#F2A619"
  }), /*#__PURE__*/createElement("path", {
    d: "M23.18 34.857a1.286 1.286 0 1 0 .012-2.572 1.286 1.286 0 0 0-.012 2.572z",
    fill: "#0D4599"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32.857 4H12.286a5.141 5.141 0 0 0-5.143 5.143H5.857A3.869 3.869 0 0 0 2 13v5.143A3.869 3.869 0 0 0 5.857 22h14.786a1.29 1.29 0 0 1 1.286 1.286v.025a3.838 3.838 0 0 0-3.613 3.382l-.887 7.521a5.786 5.786 0 1 0 11.571 0l-.887-7.521a3.84 3.84 0 0 0-3.613-3.382v-.025a3.868 3.868 0 0 0-3.857-3.857H5.857a1.29 1.29 0 0 1-1.286-1.286V13a1.29 1.29 0 0 1 1.286-1.286h1.286a5.14 5.14 0 0 0 5.143 5.143h20.571A5.14 5.14 0 0 0 38 11.714V9.143A5.14 5.14 0 0 0 32.857 4zm-7.29 22.989l.862 7.354a3.217 3.217 0 0 1-6.429 0l.861-7.354a1.294 1.294 0 0 1 1.286-1.132h2.134a1.293 1.293 0 0 1 1.286 1.132zm7.29-12.703a2.58 2.58 0 0 0 2.572-2.572V9.143a2.58 2.58 0 0 0-2.572-2.572H12.286a2.58 2.58 0 0 0-2.572 2.572v2.571a2.579 2.579 0 0 0 2.572 2.572h20.571z",
    fill: "#0D4599"
  }));
};

Painter.defaultProps = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};

var ForSale = function ForSale(props) {
  return /*#__PURE__*/createElement("svg", props, /*#__PURE__*/createElement("path", {
    d: "M30 2c-6.075 0-11 4.925-11 11v24a3 3 0 0 0 3 3h16a3 3 0 0 0 3-3V13c0-6.075-4.925-11-11-11z",
    fill: "#A6E5FF"
  }), /*#__PURE__*/createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M37.8 11.153H10.766V7.2a1.289 1.289 0 0 0-2.572 0v3.953H4.2a1.289 1.289 0 0 0 0 2.57h3.994V40.8a1.289 1.289 0 0 0 2.572 0V13.724h5.143V16.3a2.58 2.58 0 0 0-2.572 2.572v11.566a2.58 2.58 0 0 0 2.572 2.572h18a2.579 2.579 0 0 0 2.57-2.572V18.867a2.579 2.579 0 0 0-2.57-2.567v-2.576h3.89a1.289 1.289 0 0 0 0-2.571zm-3.891 19.285h-18V18.867h18v11.57zM18.479 16.3h12.858v-2.576H18.48V16.3z",
    fill: "#0D4599"
  }), /*#__PURE__*/createElement("path", {
    d: "M25.992 22.14l-2.327 1.85-.463-.474a1.291 1.291 0 0 0-1.826 1.825l1.286 1.286c.244.238.572.372.913.373.291.003.575-.097.8-.283l3.214-2.571a1.281 1.281 0 1 0-1.594-2.006h-.003z",
    fill: "#F2A619"
  }));
};

ForSale.defaultProps = {
  width: "44",
  height: "44",
  viewBox: "0 0 44 44",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
var StyleWrapper$1$1 = styled.div(_templateObject$1$1 || (_templateObject$1$1 = _taggedTemplateLiteral$1(["\n    .cards {\n        margin-top: ", ";\n    }\n\n    .cards:first-child {\n        margin-top: 0;\n    }\n"])), spaceMixin('sm'));
var StyledHeading = styled(Heading)(_templateObject2$1$1 || (_templateObject2$1$1 = _taggedTemplateLiteral$1(["\n    font-family: serif;\n    font-weight: bold;\n    text-align: center;\n    margin-top: ", ";\n    margin-bottom: ", ";\n"])), spaceMixin('md'), spaceMixin('md'));
var BlueDivider = styled(Divider)(_templateObject3$1$1 || (_templateObject3$1$1 = _taggedTemplateLiteral$1(["\n    background-color: ", ";\n"])), props => props.dividerColor);

var OtherWaysToSell = _ref => {
  var {
    dividerColor,
    header,
    onClickAgentFinder,
    onClickFsbo,
    onClickSellerGuide
  } = _ref;
  return /*#__PURE__*/createElement(ThemeProvider, {
    theme: ThemeConstellation
  }, /*#__PURE__*/createElement(StyleWrapper$1$1, {
    className: "other-ways-to-sell"
  }, /*#__PURE__*/createElement(BlueDivider, {
    dividerColor: dividerColor,
    appearance: "emphasized",
    length: "fixed",
    marginX: "auto",
    marginY: "md"
  }), /*#__PURE__*/createElement(StyledHeading, {
    level: "5"
  }, header), /*#__PURE__*/createElement(OptionsCard, {
    className: "cards",
    Icon: Handshake,
    onClick: onClickAgentFinder,
    url: "/agent-finder/",
    title: "Sell with a trusted agent",
    urlText: "View agent profiles"
  }), /*#__PURE__*/createElement(OptionsCard, {
    className: "cards",
    Icon: ForSale,
    onClick: onClickFsbo,
    url: "/for-sale-by-owner/",
    title: "Sell it yourself",
    urlText: "Create a listing"
  }), /*#__PURE__*/createElement(OptionsCard, {
    className: "cards",
    Icon: Painter,
    onClick: onClickSellerGuide,
    url: "/sellers-guide/",
    title: "Learn about the selling process",
    urlText: "Go to Sellers Guide"
  })));
};

OtherWaysToSell.defaultProps = {
  dividerColor: token('colors.blue400'),
  header: 'Other ways we can help you sell',
  onClickAgentFinder: () => {},
  onClickFsbo: () => {},
  onClickSellerGuide: () => {}
};

var _excluded$8 = ["isOpen", "landingPage"];
var gaAction = 'MoreWaysToSell';

var _onClickAgentFinder = landingPage => track({
  action: gaAction,
  category: landingPage,
  label: 'AgentFinder_Click'
});

var _onClickFsbo = landingPage => track({
  action: gaAction,
  category: landingPage,
  label: 'FSBO_Click'
});

var _onClickSellerGuide = landingPage => track({
  action: gaAction,
  category: landingPage,
  label: 'SellersGuide_Click'
});

var SellerGuideDialog = _ref => {
  var {
    isOpen,
    landingPage
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded$8);

  return /*#__PURE__*/React.createElement(ModalDialog, _extends({}, props, {
    mediaQuery: {
      md: {
        fullScreen: false
      }
    },
    body: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(Heading, {
      style: {
        textAlign: 'center'
      },
      as: "h1",
      level: 4,
      marginBottom: "sm"
    }, "Sorry, this service isn\u2019t available in your area right now"), /*#__PURE__*/React.createElement(OtherWaysToSell, {
      onClickAgentFinder: () => _onClickAgentFinder(landingPage),
      onClickFsbo: () => _onClickFsbo(landingPage),
      onClickSellerGuide: () => _onClickSellerGuide(landingPage)
    })),
    isOpen: isOpen,
    wide: true,
    fullScreen: true
  }));
};

SellerGuideDialog.defaultProps = {
  isOpen: false,
  landingPage: ''
};

// fill all undefined fields on address object with empty string

var getMatchedAddress = addressSearchResult => {
  var {
    matchDetails = {}
  } = addressSearchResult;
  var matchedAddress = get(matchDetails, 'property.address', null);
  var matchedZipcode = get(matchDetails, 'zipcode', '');
  var ADDRESS_FIELDS = ['city', 'state', 'street', 'unit', 'zipcode'];

  if (matchedAddress) {
    ADDRESS_FIELDS.forEach(field => {
      if (!matchedAddress[field]) {
        matchedAddress[field] = '';
      }
    });
    return matchedAddress;
  }

  if (matchedZipcode) {
    matchedAddress = {
      zipcode: matchedZipcode
    };
    ADDRESS_FIELDS.forEach(field => {
      if (matchDetails[field]) {
        // prefill city, state
        matchedAddress[field] = matchDetails[field];
      } else {
        matchedAddress[field] = '';
      }
    });
    return matchedAddress;
  }

  return null;
};

// only display Rewards DAE when user enter from FS HDP rewards zipcode upsell
var getDialogTitle = _ref => {
  var {
    entrySource,
    isFromAutoSubmit,
    zipcode
  } = _ref;
  var isFromForSaleHDPRewardsUpsell = isFromAutoSubmit && (entrySource === null || entrySource === void 0 ? void 0 : entrySource.startsWith('fshdp')) && (entrySource === null || entrySource === void 0 ? void 0 : entrySource.endsWith('zo-rewards-unlock-savings-zipcode-check'));
  var nextDialogTitlePrefix = isFromForSaleHDPRewardsUpsell ? 'Zillow Rewards' : 'Zillow Offers';
  var nextDialogTitle = "".concat(nextDialogTitlePrefix, " is available in ").concat(zipcode);
  return nextDialogTitle;
};

var ZatPhoneLink = () => /*#__PURE__*/React.createElement(Anchor, {
  href: "tel:".concat(PhoneNumbers.ZILLOW_ADVISOR_TEAM)
}, PhoneNumbers.ZILLOW_ADVISOR_TEAM_DISPLAY);

var Messages = {
  ADDRESS_NOT_FOUND: "Sorry, we couldn't find that address.",
  CONTACT_FORM_ERROR: "Sorry, we're having technical issues, please try again.",
  CONTACT_FORM_ERROR_LONG: 'Sorry, we are experiencing some technical difficulties right now. Please try again after some time.',
  CONTACT_FORM_INVALID_EMAIL: 'Please enter a valid email address to get updates.',
  CONTACT_FORM_SUBMIT_FAILURE: "Sorry, we couldn't get an offer at this time, please try again.",
  CONTACT_FORM_SUBMIT_INVALID_EMAIL: 'Please enter a valid email address to get an offer.',
  DUPLICATE_REQUEST: /*#__PURE__*/React.createElement(React.Fragment, null, "We are unable to process your request. If you would like to make changes to an existing request for offers, call us at ", /*#__PURE__*/React.createElement(ZatPhoneLink, null), "."),
  SERVER_ERROR: 'Sorry, our service is unavailable at this time.',
  USERS_OWN_DUPLICATE_REQUEST: /*#__PURE__*/React.createElement(React.Fragment, null, "You have an open offer request on this home. If you would like to make changes to this request, call us at ", /*#__PURE__*/React.createElement(ZatPhoneLink, null), ".")
};

var ADDRESS_SEARCH_FORM_PLACEHOLDER = 'Enter full home address';

// leadTypes match OASIS model response
// https://gitlab.zgtools.net/zillow-offers/growth/oasis-model/-/blob/master/src/main/java/com/zillow/offeravail/model/api/LeadType.java
var LeadTypes = {
  PARTNER_LEADS: 'PARTNER_LEADS',
  PARTNER_LEADS_INTEREST_LIST: 'PARTNER_LEADS_INTEREST_LIST',
  ZILLOW_360: 'ZILLOW_360'
};

var {
  PARTNER_LEADS_INTEREST_LIST,
  ZILLOW_360
} = LeadTypes;
var DAE_TITLE_DEFAULT = 'Enter your address';
var DAE_TITLE_REENTER = 'Re-enter your address';
var DAEDialogs = {
  CONFIRM_ADDRESS: 'CONFIRM_ADDRESS',
  DETAILED_ADDRESS_ENTRY: 'DETAILED_ADDRESS_ENTRY',
  LEAD_CONTACT_FORM: 'LEAD_CONTACT_FORM',
  SELECT_ADDRESS: 'SELECT_ADDRESS',
  SELLER_GUIDE: 'SELLER_GUIDE',
  ZIP_CODE_ENTRY: 'ZIP_CODE_ENTRY'
};
var analyticsEventActions = {
  addressSubmit: 'LPAddressSubmit',
  interestListModal: 'InterestListModal',
  leadFormModal: 'LeadFormModal'
}; // These functions exist because we're moving in a direction of not setting detailedAddressSearchResult and
// zoIneligibleDetails independently. Seller advisor pages look at these to figure out how they were entered, so we
// need to make sure only one is set. Otherwise, the pages can get confused as to how they were entered.

var clearIneligibleMatchDetails = () => {
  clearDetailedAddressSearchResult();
  saveZoIneligibleDetails(null);
  saveMatchedPropertyEligibilityDetails(null);
};

var saveIneligibleZipcodeMatchDetails = details => {
  setDetailedAddressSearchResult(details);
  saveZoIneligibleDetails(null);
}; // creates an encoded URI to handle special characters


var createRelativeUri = _ref => {
  var {
    path,
    queryParams
  } = _ref;
  var uri = "".concat(path);
  var query = Object.entries(queryParams).map(_ref2 => {
    var [key, value] = _ref2;
    return "".concat(key, "=").concat(encodeURIComponent(value));
  }).join('&');

  if (query) {
    uri += "?".concat(query);
  }

  return uri;
}; // API for string address search


var createRelativeAddressSearchUri = query => createRelativeUri({
  path: Urls.ZILLOW_OFFERS_ADDRESS_SEARCH,
  queryParams: {
    query
  }
}); // API for detailed address search


var createRelativeDetailedAddressSearchUri = _ref3 => {
  var {
    city,
    street,
    state,
    unit,
    zipcode
  } = _ref3;
  return createRelativeUri({
    path: Urls.ZILLOW_OFFERS_DETAILED_ADDRESS_SEARCH,
    queryParams: {
      city,
      state,
      street,
      unit,
      zipcode
    }
  });
}; // creates a string of the address returned by jumpstart for defaultAutofillAddress in form


var createAddressSearchResultString = matchDetails => Object.values(matchDetails.property.address).join(' '); // tracking


var trackAddressFlowSuccess = /*#__PURE__*/function () {
  var _ref4 = _asyncToGenerator(function* () {
    try {
      yield trackAsync(event('zo.zpidsearch.success', {
        action_is_auto: true,
        content: 'zpid',
        ga_action: 'LandingPageSubmit',
        ga_label: 'Success'
      }));
    } catch (err) {
      // We don't want to block the user due to issues sending events; capture and move on.
      captureException(err, {
        level: 'warning'
      });
    }
  });

  return function trackAddressFlowSuccess() {
    return _ref4.apply(this, arguments);
  };
}();

var trackLandingPageSubmitFailure = /*#__PURE__*/function () {
  var _ref6 = _asyncToGenerator(function* (_ref5) {
    var {
      reason,
      value = undefined
    } = _ref5;

    try {
      yield trackAsync(event('zo.zpidsearch.failure', {
        action_is_auto: true,
        content: reason,
        ga_action: 'LandingPageSubmit',
        ga_label: "Failure/".concat(reason),
        ga_value: value
      }));
    } catch (err) {
      // We don't want to block the user due to issues sending events; capture and move on.
      captureException(err, {
        level: 'warning'
      });
    }
  });

  return function trackLandingPageSubmitFailure(_x) {
    return _ref6.apply(this, arguments);
  };
}();

var trackIneligibleAddressSubmit = /*#__PURE__*/function () {
  var _ref7 = _asyncToGenerator(function* (landingPage) {
    track({
      action: analyticsEventActions.addressSubmit,
      category: landingPage,
      label: 'Ineligible'
    });
  });

  return function trackIneligibleAddressSubmit(_x2) {
    return _ref7.apply(this, arguments);
  };
}();

var trackEligibleAddressSubmit = landingPage => track({
  action: analyticsEventActions.addressSubmit,
  category: landingPage,
  label: 'Eligible'
});

class ZOAddressSearch extends React.Component {
  constructor(props) {
    var _this, _getGlobalWindow, _getGlobalWindow$loca;

    super(props);
    _this = this;

    _defineProperty(this, "setStateAsync", /*#__PURE__*/function () {
      var _ref8 = _asyncToGenerator(function* (nextState) {
        var timeoutMillis = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5000;
        return new Promise((resolve, reject) => {
          _this.setState(nextState, resolve); // Hopefully, React will call the setState callback before the timeout and the Promise will
          // resolve. But if somehow React fails to call the callback or fails to call it quickly
          // enough, then the Promise will instead reject.


          window.setTimeout(() => reject(new Error("setState callback not called within ".concat(timeoutMillis, " milliseconds"))), timeoutMillis);
        });
      });

      return function (_x3) {
        return _ref8.apply(this, arguments);
      };
    }());

    _defineProperty(this, "checkEligibility", /*#__PURE__*/function () {
      var _ref9 = _asyncToGenerator(function* (zpid) {
        var isFromAutoSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (!zpid) {
          throw new Error('zpid is missing!');
        }

        if (_this.props.onResolvedZpid) {
          _this.props.onResolvedZpid(zpid);
        } else {
          yield _this.setStateAsync({
            pendingOnCheckingZOEligibility: true
          });

          try {
            _this.props.onCheckZOEligibilityStarted();

            var response = yield _this.axiosInstance.get("".concat(_this.props.origin).concat(createRelativeUri({
              path: Urls.LEAD_ELIGIBILITY_CHECK,
              queryParams: {
                zpid
              }
            }))); // in case the user was previously terminated in the last ZO eligibility check, clean up the
            // ineligibility details

            clearIneligibleMatchDetails();
            var responseData = get(response, 'data', false);
            var nextPageRoute = null;
            var eligibilityDetails = null;
            var nextDialog = null;
            yield trackAddressFlowSuccess();
            ({
              eligibilityDetails,
              nextPageRoute,
              nextDialog
            } = yield _this.handleEligibleZpid(zpid, responseData));

            var preventDefault = _this.props.onCheckZOEligibilitySucceeded({
              eligibilityDetails,
              isEligible: true,
              nextPageRoute,
              zpid
            });

            if (preventDefault) {
              _this.onCloseDAEDialog();
            } else if (nextDialog) {
              // Temporary until we have the form for partner lead interest list
              _this.setState({
                currentDisplayingDialog: nextDialog
              });
            } else if (nextPageRoute) {
              saveMatchedPropertyEligibilityDetails(eligibilityDetails);

              _this.redirectTo(_objectSpread2(_objectSpread2({}, nextPageRoute), {}, {
                isFromAutoSubmit
              }));
            }
          } catch (jmpErr) {
            var _jmpErr$response;

            var result = (jmpErr === null || jmpErr === void 0 ? void 0 : (_jmpErr$response = jmpErr.response) === null || _jmpErr$response === void 0 ? void 0 : _jmpErr$response.data) || {};
            var {
              errorName = 'UNKNOWN_REASON'
            } = result;
            yield trackLandingPageSubmitFailure({
              reason: errorName
            });
            var checkZOEligibilityError = Messages.SERVER_ERROR; // Jmp already determines if a signed in user is the owner of the request.
            // We can determine which duplicate error to show based on the existence of dashboard url

            if (errorName === 'ADDRESS_NOT_FOUND') {
              checkZOEligibilityError = Messages.ADDRESS_NOT_FOUND;
            } else {
              captureException(jmpErr);
            }

            _this.setState({
              checkZOEligibilityError,
              pendingOnCheckingZOEligibility: false
            }, () => {
              _this.onCloseDAEDialog();

              _this.props.onCheckZOEligibilityFailed();
            });
          } finally {
            _this.setState({
              pendingOnCheckingZOEligibility: false
            });
          }
        }
      });

      return function (_x4) {
        return _ref9.apply(this, arguments);
      };
    }());

    _defineProperty(this, "handleEligibleZpid", /*#__PURE__*/function () {
      var _ref10 = _asyncToGenerator(function* (propertyId) {
        var _eligibilityDetails$z;

        var responseData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
        // fetch propertyInfo from GDP
        var propertyInfo = yield _this.gdpClient.fetchPropertyInfo(propertyId);

        var eligibilityDetails = _objectSpread2(_objectSpread2({}, propertyInfo), {}, {
          city: startCase((propertyInfo.city || '').toLowerCase()),
          // e.g. LAS VEGAS -> Las Vegas
          propertyId
        }, responseData);

        var nextPageRoute = responseData !== null && responseData !== void 0 && responseData.redirectUrl ? {
          url: responseData === null || responseData === void 0 ? void 0 : responseData.redirectUrl
        } : null;

        var isEligible = _this.props.eligibleLeadTypes.includes(responseData === null || responseData === void 0 ? void 0 : responseData.leadType);

        if (isEligible) {
          trackEligibleAddressSubmit(_this.state.landingPage);
        } else {
          yield trackIneligibleAddressSubmit(_this.state.landingPage);
        }

        var leadPayload = {};
        var {
          city,
          state,
          streetAddress,
          zipcode
        } = eligibilityDetails;
        leadPayload.zpid = eligibilityDetails.propertyId;
        leadPayload.zoMarketName = ((_eligibilityDetails$z = eligibilityDetails.zillowOfferMarket) === null || _eligibilityDetails$z === void 0 ? void 0 : _eligibilityDetails$z.name) || null;
        leadPayload.address = "".concat(streetAddress, ", ").concat(city, ", ").concat(state, " ").concat(zipcode);

        _this.setState({
          leadPayload,
          leadType: responseData === null || responseData === void 0 ? void 0 : responseData.leadType
        });

        return {
          eligibilityDetails,
          nextDialog: DAEDialogs.LEAD_CONTACT_FORM,
          nextPageRoute
        };
      });

      return function (_x5) {
        return _ref10.apply(this, arguments);
      };
    }());

    _defineProperty(this, "buildMergedQuery", query => {
      var globalWindow = getGlobalWindow();
      var queryForItc = this.props.internalTrackingCode ? "itc=".concat(this.props.internalTrackingCode) : '';
      var queryForEntrySource = this.props.entrySource ? "t=".concat(this.props.entrySource) : '';
      var queryFromUrl = globalWindow.location.search.slice(1); // remove the leading '?'
      // the order matters, it determines how duplicated url parameters are merged

      return queryString$1.merge(queryFromUrl, query, queryForItc, queryForEntrySource);
    });

    _defineProperty(this, "redirectTo", _ref11 => {
      var {
        url,
        query,
        isFromAutoSubmit = false
      } = _ref11;
      var globalWindow = getGlobalWindow();
      var mergedQuery = this.buildMergedQuery(query);
      this.resetDetailedAddressSearchStates();
      var fullUrl = "".concat(url, "?").concat(mergedQuery);

      if (isFromAutoSubmit || getIsAppWebView()) {
        globalWindow.location.replace(fullUrl);
      } else {
        globalWindow.location.assign(fullUrl);
      }
    });

    _defineProperty(this, "navigateTo", _ref12 => {
      var {
        path,
        query,
        isFromAutoSubmit = false
      } = _ref12;
      var globalWindow = getGlobalWindow();
      var url = "".concat(ZILLOW_OFFERS_BASE_NAME).concat(path);
      var mergedQuery = this.buildMergedQuery(query);

      if (mergedQuery) {
        url = "".concat(url, "?").concat(mergedQuery);
      } // Normally, the react component tree will be torn down and all states will be cleared
      // when navigating away from current page. But sometimes that's not the case for Safari.
      // So we explicitly close the DAE dialog and clear up the search result before navigation.


      this.resetDetailedAddressSearchStates(); // RE App webview differs from desktop browsers that location.assign will open a new
      // webview instance. This can cause undesired effect of not reloading the page when user
      // navigates back because the previous webview instance is still alive.
      // So we use location.replace when it is in RE App webview.

      if (isFromAutoSubmit || getIsAppWebView()) {
        globalWindow.location.replace(url);
      } else {
        globalWindow.location.assign(url);
      }
    });

    _defineProperty(this, "onCloseDAEDialog", () => {
      this.resetDetailedAddressSearchStates();
      this.setState({
        isDAEOpenByAutoSubmit: false
      });
    });

    _defineProperty(this, "onDetailedAddressEntrySubmit", /*#__PURE__*/function () {
      var _ref13 = _asyncToGenerator(function* (nextSearchedFullAddress) {
        _this.props.onDetailedAddressSubmitStarted();

        var lastMatchedFullAddress = getMatchedAddress(_this.state.addressSearchResult);
        var searchTextChanged = !isEqual(nextSearchedFullAddress, _this.state.lastSearchedFullAddress);
        var shouldCountAsRetry = // initial search
        _this.state.lastSearchedFullAddress === null || // the address to search remained unchanged
        // and the address to search is different from previous search result
        !searchTextChanged && !isEqual(lastMatchedFullAddress, _this.state.lastSearchedFullAddress);

        if (searchTextChanged) {
          _this.setState({
            lastSearchedFullAddress: nextSearchedFullAddress
          });
        } // reset retry count


        var retry = _this.state.numOfDetailedAddressSearches;

        if (shouldCountAsRetry) {
          if (retry < 3) {
            _this.setState({
              numOfDetailedAddressSearches: retry + 1
            });
          } else {
            _this.setState({
              addressSearchError: "Fail to search ".concat(nextSearchedFullAddress.street, ", have tried ").concat(retry, " times already.")
            });

            return;
          }
        } else {
          _this.setState({
            numOfDetailedAddressSearches: 0
          });
        }

        try {
          var response = yield _this.axiosInstance.get("".concat(_this.props.origin).concat(createRelativeDetailedAddressSearchUri(nextSearchedFullAddress)));
          var addressSearchResult = get(response, 'data', {});

          _this.setState({
            addressSearchResult
          });

          var {
            subType,
            type,
            matchDetails
          } = addressSearchResult;
          var addressSearchResultString = matchDetails ? createAddressSearchResultString(matchDetails) : '';

          if (type === 'ZPID_MATCH' && subType === 'EXACT') {
            _this.setState({
              addressSearchError: '',
              currentDisplayingDialog: DAEDialogs.CONFIRM_ADDRESS,
              defaultAutofillAddress: addressSearchResultString
            });
          } else {
            var err = new Error("Error matching type ".concat(type, " and ").concat(subType, " for detailed address search"));
            err.response = {
              status: 404
            };
            throw err;
          }

          _this.props.onDetailedAddressSubmitSucceeded({
            addressSearchResult
          });
        } catch (err) {
          if (get(err, 'response.status') === 404) {
            _this.setState({
              addressSearchError: Messages.ADDRESS_NOT_FOUND
            });
          } else {
            _this.setState({
              addressSearchError: Messages.SERVER_ERROR
            });
          }

          _this.props.onDetailedAddressSubmitFailed();
        }
      });

      return function (_x6) {
        return _ref13.apply(this, arguments);
      };
    }());

    _defineProperty(this, "onZipcodeInputSubmit", /*#__PURE__*/function () {
      var _ref14 = _asyncToGenerator(function* (zipcode) {
        _this.setState({
          addressSearchError: '',
          addressSearchResult: {},
          daeDialogTitle: DAE_TITLE_DEFAULT,
          lastSearchedFullAddress: null,
          numOfDetailedAddressSearches: 0,
          pendingOnAddressSearch: false
        });

        _this.props.onZipcodeSubmitStarted();

        var nextDialog = _this.state.currentDisplayingDialog;
        var nextDialogTitle = _this.state.daeDialogTitle;
        var nextPageRoute = null;
        var isEligible = null;

        try {
          _this.setState({
            pendingOnAddressSearch: true
          });

          var response = yield _this.axiosInstance.get("".concat(_this.props.origin).concat(createRelativeAddressSearchUri(zipcode)));
          var addressSearchResult = get(response, 'data', {});

          _this.setState({
            addressSearchResult
          });

          var {
            subType,
            type,
            matchDetails = {}
          } = addressSearchResult;

          if (type === 'REGION_MATCH' && subType === 'ZIPCODE') {
            if (matchDetails.isOfferEligible) {
              trackEligibleAddressSubmit(_this.state.landingPage);
              nextDialog = DAEDialogs.DETAILED_ADDRESS_ENTRY;
              nextDialogTitle = "Zillow Offers is available in ".concat(matchDetails.zipcode);
              isEligible = true;
            } else {
              yield trackIneligibleAddressSubmit(_this.state.landingPage);
              saveIneligibleZipcodeMatchDetails(addressSearchResult);
              nextPageRoute = {
                path: ZillowOffersGrowthRoutes.SELLER_ADVISOR_EMAIL_WAITLIST
              };
              isEligible = false;
            }
          } else {
            var err = new Error("Unexpected type ".concat(type, " and subtype ").concat(subType, " for a zip code search"));
            err.response = {
              status: 404
            };
            throw err;
          }

          var preventNavigation = _this.props.onZipcodeSubmitSucceeded({
            isEligible,
            nextPageRoute
          });

          if (nextPageRoute) {
            if (!preventNavigation) {
              _this.navigateTo(nextPageRoute);
            } else {
              _this.onCloseDAEDialog();
            }
          } else {
            _this.setState({
              currentDisplayingDialog: nextDialog,
              daeDialogTitle: nextDialogTitle
            });
          }
        } catch (err) {
          _this.props.onZipcodeSubmitFailed();

          if (get(err, 'response.status') === 404) {
            trackIneligibleAddressSubmit(_this.state.landingPage);

            _this.setState({
              addressSearchError: Messages.ADDRESS_NOT_FOUND
            });
          } else {
            _this.setState({
              addressSearchError: Messages.SERVER_ERROR
            });
          }

          _this.setState({
            currentDisplayingDialog: nextDialog,
            daeDialogTitle: nextDialogTitle
          });
        }

        _this.setState({
          pendingOnAddressSearch: false
        });
      });

      return function (_x7) {
        return _ref14.apply(this, arguments);
      };
    }());

    _defineProperty(this, "onAddressSearchFormSubmit", /*#__PURE__*/function () {
      var _ref15 = _asyncToGenerator(function* (addressSearchText) {
        var isFromAutoSubmit = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

        if (!addressSearchText) {
          return;
        }

        var searchText = addressSearchText.trim();

        if (!searchText) {
          _this.setState({
            currentDisplayingDialog: DAEDialogs.DETAILED_ADDRESS_ENTRY
          });

          return;
        }

        _this.props.onAddressSubmitStarted({
          isFromAutoSubmit
        });

        _this.resetDetailedAddressSearchStates();

        try {
          var nextDialog = _this.state.currentDisplayingDialog;
          var nextDialogTitle = _this.state.daeDialogTitle;
          var nextPageRoute = null;

          _this.setState({
            pendingOnAddressSearch: true
          });

          var response = yield _this.axiosInstance.get("".concat(_this.props.origin).concat(createRelativeAddressSearchUri(searchText)));
          var addressSearchResult = get(response, 'data', {});

          _this.setState({
            addressSearchResult
          });

          var {
            type,
            subType,
            matchDetails
          } = addressSearchResult;

          if (type === 'ZPID_MATCH' && subType === 'EXACT') {
            nextDialog = DAEDialogs.CONFIRM_ADDRESS;
          } else if (type === 'ZPID_MATCH' && subType === 'MULTIPLE') {
            nextDialog = DAEDialogs.SELECT_ADDRESS;
          } else if (type === 'REGION_MATCH' && subType === 'OTHER') {
            nextDialog = DAEDialogs.ZIP_CODE_ENTRY;
          } else if (type === 'REGION_MATCH' && subType === 'ZIPCODE') {
            var {
              isOfferEligible,
              zipcode
            } = matchDetails;

            if (isOfferEligible) {
              trackEligibleAddressSubmit(_this.state.landingPage);
              nextDialog = DAEDialogs.DETAILED_ADDRESS_ENTRY;
              nextDialogTitle = getDialogTitle({
                entrySource: getEntrySource(),
                isFromAutoSubmit,
                zipcode
              });
            } else {
              yield trackIneligibleAddressSubmit(_this.state.landingPage);
              saveIneligibleZipcodeMatchDetails(addressSearchResult);
              nextPageRoute = {
                path: ZillowOffersGrowthRoutes.SELLER_ADVISOR_EMAIL_WAITLIST
              };
            }
          } else {
            var err = new Error("Unexpected matching type ".concat(type));
            err.response = {
              status: 404
            };
            throw err;
          }

          var preventNavigation = _this.props.onAddressSubmitSucceeded({
            addressSearchResult,
            nextPageRoute
          });

          if (nextPageRoute) {
            if (!preventNavigation) {
              _this.navigateTo(nextPageRoute);
            }
          } else {
            _this.setState({
              currentDisplayingDialog: nextDialog,
              daeDialogTitle: nextDialogTitle
            });
          }
        } catch (err) {
          if (get(err, 'response.status') === 404) {
            _this.setState({
              currentDisplayingDialog: DAEDialogs.DETAILED_ADDRESS_ENTRY,
              daeDialogTitle: DAE_TITLE_REENTER
            });
          } else {
            _this.setState({
              addressSearchError: Messages.SERVER_ERROR
            });
          }

          _this.props.onAddressSubmitFailed();
        }

        _this.setState({
          isDAEOpenByAutoSubmit: isFromAutoSubmit,
          pendingOnAddressSearch: false
        });
      });

      return function (_x8) {
        return _ref15.apply(this, arguments);
      };
    }());

    _defineProperty(this, "resetDetailedAddressSearchStates", () => {
      this.setState({
        addressSearchError: '',
        addressSearchResult: {},
        currentDisplayingDialog: '',
        daeDialogTitle: DAE_TITLE_DEFAULT,
        lastSearchedFullAddress: null,
        numOfDetailedAddressSearches: 0,
        pendingOnAddressSearch: false
      });
    });

    _defineProperty(this, "onCloseErrorDialog", () => {
      this.setState({
        addressForDuplicateOfferRequest: null,
        checkZOEligibilityError: '',
        sellerDashboardUrl: null
      });
    });

    _defineProperty(this, "resolveLandingPage", surfaceID => {
      var landingPagePrefix = 'Offers';

      if (surfaceID === 'sell-lp') {
        landingPagePrefix = 'Sell';
      } else if (surfaceID === 'z360-lp') {
        landingPagePrefix = '360';
      }

      return "".concat(landingPagePrefix, "LandingPage");
    });

    this.axiosInstance = axios.create({
      timeout: 30000,
      validateStatus: status => status >= 200 && status < 300
    });
    this.gdpClient = new GDPClient({
      origin: this.props.origin
    }); // make sure all zo-address-search GA events are attached with correct cd51

    setdim({
      dimension51: this.props.internalTrackingCode
    });
    var {
      t,
      zpid: _zpid
    } = queryString$1.parse((_getGlobalWindow = getGlobalWindow()) === null || _getGlobalWindow === void 0 ? void 0 : (_getGlobalWindow$loca = _getGlobalWindow.location) === null || _getGlobalWindow$loca === void 0 ? void 0 : _getGlobalWindow$loca.search) || {};
    this.state = {
      addressForDuplicateOfferRequest: {},
      addressSearchError: '',
      addressSearchResult: {},
      checkZOEligibilityError: '',
      currentDisplayingDialog: '',
      daeDialogTitle: DAE_TITLE_DEFAULT,
      landingPage: props.landingPage || this.resolveLandingPage(props.surfaceID),
      lastSearchedFullAddress: null,
      leadPayload: {},
      leadSource: t || props.surfaceID,
      leadType: PARTNER_LEADS_INTEREST_LIST,
      numOfDetailedAddressSearches: 0,
      pendingOnAddressSearch: false,
      pendingOnCheckingZOEligibility: false,
      queryStringZpid: _zpid,
      sellerDashboardUrl: null
    };
  }

  componentDidMount() {
    var _this2 = this;

    return _asyncToGenerator(function* () {
      var {
        onResolvedZpid,
        shouldAutoSubmit,
        prefilledZpid,
        prefilledAddress,
        shouldAutoDisplayDAE
      } = _this2.props;
      var actualPrefilledZpid = prefilledZpid || _this2.state.queryStringZpid;

      try {
        if (shouldAutoSubmit) {
          if (actualPrefilledZpid) {
            // make a eligibility check call using the prefilled zpid
            yield _this2.checkEligibility(actualPrefilledZpid, true);
          } else if (prefilledAddress) {
            // make a address search call using the prefilled address
            _this2.onAddressSearchFormSubmit(prefilledAddress, true);
          } else {
            var jsonEncodedValues = JSON.stringify({
              prefilledAddress,
              prefilledZpid,
              shouldAutoSubmit
            });
            throw new Error("In ZOAddressSearch, the shouldAutoSubmit prop was a truthy value, but the" + " prefilledZpid and prefilledAddress props were both falsy (at least one" + " should have been truthy). ".concat(jsonEncodedValues));
          }
        } else if (shouldAutoDisplayDAE) {
          _this2.setState({
            currentDisplayingDialog: DAEDialogs.DETAILED_ADDRESS_ENTRY
          });
        } else if (actualPrefilledZpid && onResolvedZpid) {
          onResolvedZpid(actualPrefilledZpid);
        }
      } catch (err) {
        captureException(err);
      }
    })();
  }

  render() {
    var {
      addressForDuplicateOfferRequest,
      addressSearchError,
      addressSearchResult,
      defaultAutofillAddress,
      landingPage,
      leadSource,
      leadType,
      leadPayload,
      checkZOEligibilityError,
      currentDisplayingDialog,
      pendingOnCheckingZOEligibility,
      pendingOnAddressSearch
    } = this.state;
    var {
      useUserInfo: {
        email,
        name,
        phone
      },
      surfaceID,
      onLeadSubmitFailed,
      onLeadSubmitSucceeded
    } = this.props;
    var errorDialog;

    if (checkZOEligibilityError === Messages.USERS_OWN_DUPLICATE_REQUEST || checkZOEligibilityError === Messages.DUPLICATE_REQUEST) {
      errorDialog = /*#__PURE__*/React.createElement(DuplicateErrorDialog, {
        address: addressForDuplicateOfferRequest,
        errorMessage: checkZOEligibilityError,
        dashboardUrl: this.state.sellerDashboardUrl,
        isOpen: Boolean(checkZOEligibilityError),
        onClose: this.onCloseErrorDialog
      });
    } else {
      errorDialog = /*#__PURE__*/React.createElement(GenericErrorDialog, {
        errorMessage: checkZOEligibilityError,
        isOpen: Boolean(checkZOEligibilityError),
        onClose: this.onCloseErrorDialog
      });
    }

    return /*#__PURE__*/React.createElement("div", {
      className: this.props.className,
      style: {
        width: '100%'
      }
    }, /*#__PURE__*/React.createElement(AddressSearchForm, {
      isButtonDisabled: this.props.ctaButtonDisabled,
      buttonText: this.props.ctaButtonText,
      defaultAutofillAddress: defaultAutofillAddress,
      errorMessage: addressSearchError || checkZOEligibilityError,
      isPending: pendingOnAddressSearch || pendingOnCheckingZOEligibility,
      landingPage: landingPage,
      onChange: address => {
        this.setState({
          addressSearchError: '',
          checkZOEligibilityError: ''
        });
        this.props.onChange(address);
      },
      onChoice: zpid => {
        if (!this.props.ctaButtonDisabled) {
          this.checkEligibility(zpid);
        }
      },
      onFocus: this.props.onFocus,
      onSubmit: this.onAddressSearchFormSubmit,
      id: this.props.id,
      addressSearchFormPlaceholder: this.props.addressSearchFormPlaceholder
    }), /*#__PURE__*/React.createElement(ZipCodeInputDialog, {
      hasError: !!addressSearchError,
      isOpen: currentDisplayingDialog === DAEDialogs.ZIP_CODE_ENTRY,
      isPending: pendingOnAddressSearch,
      onClose: this.onCloseDAEDialog,
      onSubmit: this.onZipcodeInputSubmit
    }), /*#__PURE__*/React.createElement(SelectAddressDialog, {
      isOpen: currentDisplayingDialog === DAEDialogs.SELECT_ADDRESS,
      isPending: pendingOnCheckingZOEligibility,
      onClose: this.onCloseDAEDialog,
      onClickNoneOfAbove: () => this.setState({
        currentDisplayingDialog: DAEDialogs.DETAILED_ADDRESS_ENTRY,
        daeDialogTitle: DAE_TITLE_REENTER
      }),
      onSelect: this.checkEligibility,
      properties: get(addressSearchResult, 'matchDetails.properties')
    }), /*#__PURE__*/React.createElement(DetailedAddressEntryDialog, {
      address: getMatchedAddress(addressSearchResult),
      hasError: !!addressSearchError,
      isOpen: currentDisplayingDialog === DAEDialogs.DETAILED_ADDRESS_ENTRY,
      isPending: pendingOnAddressSearch,
      onClose: this.onCloseDAEDialog,
      onSubmit: this.onDetailedAddressEntrySubmit,
      title: this.state.daeDialogTitle
    }), /*#__PURE__*/React.createElement(ConfirmAddressDialog, {
      address: get(addressSearchResult, 'matchDetails.property.address'),
      apolloClient: this.gdpClient.getApolloClientInstance(),
      isOpen: currentDisplayingDialog === DAEDialogs.CONFIRM_ADDRESS,
      isPending: pendingOnCheckingZOEligibility,
      onClickConfirm: zpid => this.checkEligibility(zpid, this.state.isDAEOpenByAutoSubmit),
      onClickFixAddress: () => this.setState({
        currentDisplayingDialog: DAEDialogs.DETAILED_ADDRESS_ENTRY,
        daeDialogTitle: DAE_TITLE_REENTER
      }),
      onClose: this.onCloseDAEDialog,
      zpid: get(addressSearchResult, 'matchDetails.property.zpid')
    }), /*#__PURE__*/React.createElement(SellerGuideDialog, {
      isOpen: currentDisplayingDialog === DAEDialogs.SELLER_GUIDE,
      landingPage: landingPage,
      onClose: this.onCloseDAEDialog
    }), /*#__PURE__*/React.createElement(LeadContactForm, {
      isOpen: currentDisplayingDialog === DAEDialogs.LEAD_CONTACT_FORM,
      eligibleLeadTypes: [ZILLOW_360],
      landingPage: landingPage,
      leadSource: leadSource,
      leadType: leadType,
      lead: leadPayload,
      useUserInfo: {
        email,
        name,
        phone
      },
      surfaceID: surfaceID,
      onLeadSubmitFailed: onLeadSubmitFailed,
      onLeadSubmitSucceeded: onLeadSubmitSucceeded
    }), errorDialog);
  }

}

_defineProperty(ZOAddressSearch, "getDerivedStateFromProps", (props, state) => _objectSpread2(_objectSpread2({}, state), {}, {
  // This means defaultAutofillAddress is initialized to prefilledAddress. But if prefilledAddress is not
  // initially truthy, then defaultAutofillAddress is repeatedly assigned to prefilledAddress as
  // getDerivedStateFromProps is called until prefilledAddress becomes a truthy value. The idea is that a
  // caller might not have a value ready for prefilledAddress on the very first render (e.g., they need to
  // fetch the value from the backend), so we accept a value even after the first render.
  defaultAutofillAddress: state.defaultAutofillAddress || props.prefilledAddress
}));

ZOAddressSearch.defaultProps = {
  addressSearchFormPlaceholder: ADDRESS_SEARCH_FORM_PLACEHOLDER,
  className: '',
  ctaButtonDisabled: false,
  ctaButtonText: 'Get started',
  eligibleLeadTypes: [ZILLOW_360],
  entrySource: '',
  id: '',
  landingPage: '',
  ModalMessaging: {},
  onAddressSubmitFailed: () => {},
  onAddressSubmitStarted: () => {},
  onAddressSubmitSucceeded: () => {},
  onChange: () => {},
  onCheckZOEligibilityFailed: () => {},
  onCheckZOEligibilityStarted: () => {},
  onCheckZOEligibilitySucceeded: () => {},
  onDetailedAddressSubmitFailed: () => {},
  onDetailedAddressSubmitStarted: () => {},
  onDetailedAddressSubmitSucceeded: () => {},
  onFocus: () => {},
  onLeadSubmitFailed: () => {},
  onLeadSubmitSucceeded: () => {},
  onResolvedZpid: null,
  onZipcodeSubmitFailed: () => {},
  onZipcodeSubmitStarted: () => {},
  onZipcodeSubmitSucceeded: () => {},
  origin: '',
  prefilledAddress: '',
  prefilledZpid: null,
  shouldAutoDisplayDAE: false,
  shouldAutoSubmit: false,
  surfaceID: '',
  useUserInfo: {}
};

export default ZOAddressSearch;
export { setAutocompleteUrl, trackAddressFlowSuccess };
